import React, { useContext, useEffect, useState } from "react";
import PatientDetails from "../../../Components/PatientInformation";
import SaveAndNavigate from "../../../Components/SaveAndNavigate";
import {
  PageDesignConstants,
  SideMenuItems,
  HTTPResponse,
  ToastMessageType,
  ToastMessages,
  NDMMCohortTreatmentID,
  NDMMCohortAgent,
  NDMMPhasesId,
  NDMMCohortAgentWithSuperScript,
  SHOW_FREQUENCY_VALUES,
  DiscontinuingReasons,
} from "../../../Helpers/Enums";
import SideBarMenu from "../../../Components/SideBarMenu";
import ErrorField from "../../../Components/ErrorField";
import {
  CommonError_Msgs,
  NDMMTreatmentCohort_Msgs,
  hyperlinkTextQ21,
  predefinedReasons,
} from "../../../Helpers/HelperText";
import { AppContext } from "../../../Contexts/AppContextProvider";
import {
  GetLocalStorageData,
  GetLoggedInUserID,
  isStringEmpty,
  getMaxFirstDate,
  getMaxLastDate,
  DateInRange,
  IsAdmin,
  IsDateValid,
  IsDateAfter,
} from "../../../Helpers/Utilities";
import NDMMAgentData from "./NDMMAgentData";
import { NDMMTreatmentCohortService } from "../../../WebApiServices/NDMMTreatmentCohortService.service";
import InfoPopUp from "../../../Components/InfoPopUp";
import dayjs from "dayjs";
import NDMMDosageModification from "./NDMMDosageModification";
import DoseFrequencyModificationTable from "./DoseFrequencyModificationTable";

const NDMMTreatmentCohort = () => {
  const [rrmmAvailable, setRrmmAvailable] = useState(false);
  const navigatePaths = {
    prevPage: "/CohortDefiningTreatment",
    currPage: "/NDMMTreatmentCohort",
    nextPage: rrmmAvailable
      ? "/BispecificsCartTreatmentCohort"
      : "/LineOfTherapy",
    // nextPage: "/LineOfTherapy",
  };

  const pid = GetLocalStorageData("patientId") ?? 0;

  const storedData = GetLocalStorageData("CohortTreatment");
  let cohortTreatmentModelList = [];
  if (storedData) {
    cohortTreatmentModelList = JSON.parse(storedData);
  }
  const {
    ShowToast,
    ToggleLoader,
    HandleSessionTimeout,
    ShowActionPopUp,
    isSideMenuActive,
    setIsSideMenuActive,
  } = useContext(AppContext);
  const [showTopErrMsg, setShowTopErrMsg] = useState(false);
  const [showHideHyperlinkModal, setShowHideHyperlinkModal] = useState(false);

  const [isNewEcrfA, setIsNewEcrfA] = useState(false);
  const [
    IsLenalidomideSelectedInQ22State,
    setIsLenalidomideSelectedInQ22State,
  ] = useState(false);

  const [
    IsLenalidomideSelectedInQ24State,
    setIsLenalidomideSelectedInQ24State,
  ] = useState(false);

  const [isBortezomibSelectedInQ22, setIsBortezomibSelectedInQ22] =
    useState(false);

  const [isBortezomibSelectedInQ23, setIsBortezomibSelectedInQ23] =
    useState(false);

  const [isBortezomibSelectedInQ24, setIsBortezomibSelectedInQ24] =
    useState(false);

  const [isBortezomibSelectedInQ25, setIsBortezomibSelectedInQ25] =
    useState(false);

  const [
    IsLenalidomideSelectedInQ23State,
    setIsLenalidomideSelectedInQ23State,
  ] = useState(false);

  const [
    IsLenalidomideSelectedInQ25State,
    setIsLenalidomideSelectedInQ25State,
  ] = useState(false);

  const [earliestRRMMDate, setEarliestRRMMDate] = useState(null);

  const dosageModificationRow = {
    dosageBridgeId: null,
    ndmmPhaseId: null,

    // Column A - Date of modification
    doseStrengthReceivedRadio: null, // 1=No modification, 2=Date, 99=Unknown
    doseStrengthReceivedDate: null,

    // Column B - Dose before
    doseStrengthBeforeRadio: null, // 1=mg, 2=mg/kg, 3=mg/m², 99=Unknown
    doseStrengthBeforeUnit: null,

    // Column C - Dose after
    doseStrengthAfterRadio: null, // 1=mg, 2=mg/kg, 3=mg/m², 99=Unknown
    doseStrengthAfterUnit: null,

    // Validation flags - Column A
    showColAError: false,
    showColADateEmptyError: false,
    showColAInvalidDate: false,
    showColABeforeFirstDateError: false,
    showColAAfterLastDateError: false,

    // Validation flags - Column B
    showColBError: false,
    showColBValueError: false,
    showColBRangeError: false,
    showColBSameValueError: false,

    // Validation flags - Column C
    showColCError: false,
    showColCValueError: false,
    showColCRangeError: false,
    showColCSameValueError: false,
  };

  const bortezomibDoseFrequencyRow = {
    ndmmBortezomibDosageBridgeId: null,
    ndmmPhasesId: null,
    ndmmTreatmentAgentId: null,
    doseFrequencyReceived: null,
    doseFrequencyReceivedDate: "",
    doseFrequencyReceivedBefore: null,
    doseFrequencyBeforeUnit: null,
    doseFrequencyBeforeOthTxt: "",
    doseFrequencyReceivedAfter: null,
    doseFrequencyAfterUnit: null,
    doseFrequencyAfterOthTxt: "",

    //errors
    bortezomibDoseFreqEmptyError: false,
    bortezomibDoseFreqDateEmptyError: false,
    bortezomibDoseFreqDateInvalidError: false,
    bortezomibDoseFreqDateOFBError: false,

    bortezomibDoseFreqBeforeEmptyError: false,
    bortezomibDoseFreqBeforeUnitEmptyError: false,
    bortezomibDoseFreqBeforeRangeError: false,
    bortezomibDoseFreqBeforeUnitSameError: false,
    bortezomibDoseFreqBeforeOthTxtEmptyError: false,

    bortezomibDoseFreqAfterEmptyError: false,
    bortezomibDoseFreqAfterWeekEmptyError: false,
    bortezomibDoseFreqAfterRangeError: false,
    bortezomibDoseFreqAfterUnitSameError: false,
    bortezomibDoseFreqAfterOthTxtEmptyError: false,
  };

  //DN 23/7/24 Questions data
  const [ndmmTreatmentCohortDetails, setNDMMTreatmentCohortDetails] = useState({
    userId: GetLoggedInUserID(),

    q22_agentList: [],
    q23_agentList: [],
    q24_agentList: [],
    q25_agentList: [],
    cohortTreatmentSCT: null,

    endOfFollowUp: null,
    initialMMDiagnosisDate: null,
    lastEncounterDate: null,
    deathDate: null,
    cohortNdmmId: null,
    ndmmDisplayName: null,
    ndmmIndexDate: null,

    q21_data: null,
    q21_1_IT: true,
    q21_1_CT: false,
    q21_1_MT: false,
    q22_agentData: [],
    q23_agentData: [],
    q24_agentData: [],
    q25_agentData: [],

    q22_org_agentData: [],
    q23_org_agentData: [],
    q24_org_agentData: [],
    q25_org_agentData: [],

    nDMMAgentBridgeToDeleteLists: [],
    nDMMDosageBridgeToDeleteLists: [],
    q221_lenalidomideData: [dosageModificationRow], // Q22.1.A - Induction (phaseId = 1)
    q241_lenalidomideData: [dosageModificationRow], // Q24.1.A - Maintenance (phaseId = 3)

    q231_lenalidomideData: [dosageModificationRow], // Q23.1.A - Consolidation (phaseId = 2)
    q251_lenalidomideData: [dosageModificationRow], // Q25.1.A - 1L treatment (phaseId = 4)

    show_q21_q25: false,
    show_q21_1: false,
    show_q25: false,
    show_q25_tie: false,
    //Q22.2.A
    q22ABortezomibDoseFrequencyList: [bortezomibDoseFrequencyRow],
    q242ABortezomibDoseFrequencyList: [bortezomibDoseFrequencyRow],
    q232ABortezomibDoseFrequencyList: [bortezomibDoseFrequencyRow],
    q252ABortezomibDoseFrequencyList: [bortezomibDoseFrequencyRow],
  });

  // DN 23/7/24 Initial load
  useEffect(() => {
    async function FetchData() {
      const isRRMMAvailable = cohortTreatmentModelList.some(
        (c) => c.isEligible === true && c.ndmm === false,
      );
      setRrmmAvailable(isRRMMAvailable);
      if (isRRMMAvailable) {
        GetEarliestRrmmDate();
      }

      LoadTableData(); // Fetch all Table agent lists
      if (!isNaN(pid) && Number(pid) !== 0) {
        ToggleLoader(true);
        await GetNDMMCohortTreatmentData(); // Fetch all data of the patient & Static rows
        ToggleLoader(false);
      }
    }
    FetchData();
  }, []);

  function GetEarliestRrmmDate() {
    const earliest = cohortTreatmentModelList.reduce(
      (
        min,
        { isEligible, ndmm, cohortTreatmentID, earliestCohortIndexDate },
      ) => {
        if (
          isEligible &&
          !ndmm &&
          cohortTreatmentID > 8 &&
          earliestCohortIndexDate
        ) {
          const currentDate = new Date(earliestCohortIndexDate);

          if (!min || currentDate < new Date(min)) {
            return earliestCohortIndexDate;
          }
        }

        return min;
      },
      null,
    );

    setEarliestRRMMDate(earliest);
  }

  async function LoadTableData() {
    const response = await NDMMTreatmentCohortService.GetTableData(pid);
    if (response?.status !== HTTPResponse.OK) {
      if (response?.status === HTTPResponse.Unauthorized)
        HandleSessionTimeout();
      else if (response?.status === HTTPResponse.BadRequest)
        throw response.error;
    } else {
      const { data } = response;

      setNDMMTreatmentCohortDetails((prev) => ({
        ...prev,
        q22_agentList: data.q22_agentLists,
        q23_agentList: data.q23_agentLists,
        q24_agentList: data.q24_agentLists,
        q25_agentList: data.q25_agentLists,
      }));
    }
  }

  async function GetNDMMCohortTreatmentData() {
    try {
      let show_q21_q25 = false;
      let show_q25_tie = false;
      if (cohortTreatmentModelList?.length > 0) {
        const data = cohortTreatmentModelList.find(
          (f) => f.ndmm && f.isEligible,
        );
        if (!data) return;

        const displayName =
          data.cohortTreatmentName === "DKRd (TE or TIE)"
            ? data.cohortTreatmentSCT === 1
              ? "DKRd (TE)"
              : data.cohortTreatmentSCT === 2
                ? "DKRd (TIE)"
                : data.cohortTreatmentName
            : data.cohortTreatmentName;

        show_q21_q25 =
          data.cohortTreatmentID === NDMMCohortTreatmentID.DVRd_TE ||
          data.cohortTreatmentID === NDMMCohortTreatmentID.VRd_TE ||
          data.cohortTreatmentID === NDMMCohortTreatmentID.ISAVRD_TE ||
          (data.cohortTreatmentID === NDMMCohortTreatmentID.DKRd_TE &&
            data.cohortTreatmentSCT === 1);

        show_q25_tie =
          data.cohortTreatmentID === NDMMCohortTreatmentID.DRd_TIE ||
          data.cohortTreatmentID === NDMMCohortTreatmentID.DVRd_TIE ||
          data.cohortTreatmentID === NDMMCohortTreatmentID.VRd_TIE ||
          data.cohortTreatmentID === NDMMCohortTreatmentID.ISAVRD_TIE ||
          (data.cohortTreatmentID === NDMMCohortTreatmentID.DKRd_TIE &&
            data.cohortTreatmentSCT === 2);

        setNDMMTreatmentCohortDetails((prev) => ({
          ...prev,
          cohortNdmmId: data.cohortTreatmentID,
          ndmmDisplayName: displayName,
          ndmmIndexDate: data.cohortIndexDate,
          show_q21_q25: show_q21_q25,
          show_q25_tie: show_q25_tie,
        }));
      }

      const response =
        await NDMMTreatmentCohortService.GetNDMMCohortTreatmentData(pid);

      if (response?.status !== HTTPResponse.OK) {
        if (response?.status === HTTPResponse.Unauthorized)
          HandleSessionTimeout();
        else if (response?.status === HTTPResponse.BadRequest)
          throw response.error;
      } else {
        ToggleLoader(false);
        const { data } = response;

        setIsNewEcrfA(data.isNewEcrfA ?? false);

        let isBortezomibSelectedInQ22 = false;
        let isBortezomibSelectedInQ23 = false;
        let isBortezomibSelectedInQ24 = false;
        let isBortezomibSelectedInQ25 = false;

        let isLenalidomideSelectedInQ22 = false;
        let isLenalidomideSelectedInQ24 = false;
        let isLenalidomideSelectedInQ23 = false;
        let isLenalidomideSelectedInQ25 = false;

        if (show_q21_q25 && data.chartDifferent === true) {
          isBortezomibSelectedInQ22 = data.agentTreatmentLists?.some(
            (agent) =>
              agent.agentName === NDMMCohortAgent.Bortezomib &&
              agent.phaseid === NDMMPhasesId.InductionTherapy,
          );

          setIsBortezomibSelectedInQ22(isBortezomibSelectedInQ22);

          isBortezomibSelectedInQ24 = data.agentTreatmentLists?.some(
            (agent) =>
              agent.agentName === NDMMCohortAgentWithSuperScript.Bortezomib &&
              agent.phaseid === NDMMPhasesId.MaintenanceTherapy,
          );
          setIsBortezomibSelectedInQ24(isBortezomibSelectedInQ24);

          isBortezomibSelectedInQ23 = data.agentTreatmentLists?.some(
            (agent) =>
              agent.agentName === NDMMCohortAgentWithSuperScript.Bortezomib &&
              agent.phaseid === NDMMPhasesId.ConsolidationTherapy,
          );
          setIsBortezomibSelectedInQ23(isBortezomibSelectedInQ23);

          isLenalidomideSelectedInQ22 = data.agentTreatmentLists?.some(
            (agent) =>
              agent.agentName === NDMMCohortAgent.Lenalidomide &&
              agent.phaseid === NDMMPhasesId.InductionTherapy,
          );

          setIsLenalidomideSelectedInQ22State(isLenalidomideSelectedInQ22);

          isLenalidomideSelectedInQ24 = data.agentTreatmentLists?.some(
            (agent) =>
              agent.agentName === NDMMCohortAgentWithSuperScript.Lenalidomide &&
              agent.phaseid === 3,
          );
          setIsLenalidomideSelectedInQ24State(isLenalidomideSelectedInQ24);

          isLenalidomideSelectedInQ23 = data.agentTreatmentLists?.some(
            (agent) =>
              agent.agentName === NDMMCohortAgentWithSuperScript.Lenalidomide &&
              agent.phaseid === 2,
          );
          setIsLenalidomideSelectedInQ23State(isLenalidomideSelectedInQ23);
        }

        if (
          data.chartDifferent === false ||
          data.chartDifferent == null ||
          show_q25_tie
        ) {
          isBortezomibSelectedInQ25 = data.agentTreatmentLists?.some(
            (agent) =>
              agent.agentName === NDMMCohortAgent.Bortezomib &&
              agent.phaseid === NDMMPhasesId.OtherTherapy,
          );
          setIsBortezomibSelectedInQ25(isBortezomibSelectedInQ25);

          isLenalidomideSelectedInQ25 = data.agentTreatmentLists?.some(
            (agent) =>
              agent.agentName === NDMMCohortAgent.Lenalidomide &&
              agent.phaseid === 4,
          );
          setIsLenalidomideSelectedInQ25State(isLenalidomideSelectedInQ25);
        }
        const bortezomibSource = data?.bortezomibDoseFrequencyList ?? [];

        const q22ABortezomibDoseFrequencyList = MapBortezomibByPhase(
          bortezomibSource,
          NDMMPhasesId.InductionTherapy,
          isBortezomibSelectedInQ22,
        );

        const q242ABortezomibDoseFrequencyList = MapBortezomibByPhase(
          bortezomibSource,
          NDMMPhasesId.MaintenanceTherapy,
          isBortezomibSelectedInQ24,
        );

        const q232ABortezomibDoseFrequencyList = MapBortezomibByPhase(
          bortezomibSource,
          NDMMPhasesId.ConsolidationTherapy,
          isBortezomibSelectedInQ23,
        );

        const q252ABortezomibDoseFrequencyList = MapBortezomibByPhase(
          bortezomibSource,
          NDMMPhasesId.OtherTherapy,
          isBortezomibSelectedInQ25,
        );

        const lenalidomideSource = data?.lenalidomideDosageLists ?? [];

        const finalQ221Data = MapLenalidomideByPhase(
          lenalidomideSource,
          NDMMPhasesId.InductionTherapy,
          isLenalidomideSelectedInQ22,
        );
        const finalQ231Data = MapLenalidomideByPhase(
          lenalidomideSource,
          NDMMPhasesId.ConsolidationTherapy,
          isLenalidomideSelectedInQ23,
        );
        const finalQ241Data = MapLenalidomideByPhase(
          lenalidomideSource,
          NDMMPhasesId.MaintenanceTherapy,
          isLenalidomideSelectedInQ24,
        );
        const finalQ251Data = MapLenalidomideByPhase(
          lenalidomideSource,
          NDMMPhasesId.OtherTherapy,
          isLenalidomideSelectedInQ25,
        );

        setNDMMTreatmentCohortDetails((prev) => ({
          ...prev,
          endOfFollowUp: data.endOfFollowUpDate,
          initialMMDiagnosisDate: data.initialMMDiagnosisDate,
          lastEncounterDate: data.lastEncounterDate,
          deathDate: data.deathDate,
          show_q21_1: data.chartDifferent,
          show_q25: data.chartDifferent === false ? true : false,
          q21_data:
            data.chartDifferent === true
              ? 1
              : data.chartDifferent === false
                ? 2
                : 0,
          q21_1_IT: data.inductionPhase,
          q21_1_CT: data.consolidatePhase,
          q21_1_MT: data.maintenancePhase,
          q22_agentData:
            data.agentTreatmentLists != null
              ? data.agentTreatmentLists.filter((p) => p.phaseid === 1)
              : [],
          q23_agentData:
            data.agentTreatmentLists != null
              ? data.agentTreatmentLists.filter((p) => p.phaseid === 2)
              : [],
          q24_agentData:
            data.agentTreatmentLists != null
              ? data.agentTreatmentLists.filter((p) => p.phaseid === 3)
              : [],
          q25_agentData:
            data.agentTreatmentLists != null
              ? data.agentTreatmentLists.filter((p) => p.phaseid === 4)
              : [],
          q22_org_agentData:
            data.agentTreatmentLists != null
              ? data.agentTreatmentLists.filter((p) => p.phaseid === 1)
              : [],
          q23_org_agentData:
            data.agentTreatmentLists != null
              ? data.agentTreatmentLists.filter((p) => p.phaseid === 2)
              : [],
          q24_org_agentData:
            data.agentTreatmentLists != null
              ? data.agentTreatmentLists.filter((p) => p.phaseid === 3)
              : [],
          q25_org_agentData:
            data.agentTreatmentLists != null
              ? data.agentTreatmentLists.filter((p) => p.phaseid === 4)
              : [],
          nDMMAgentBridgeToDeleteLists: [],

          q22ABortezomibDoseFrequencyList: q22ABortezomibDoseFrequencyList,

          q221_lenalidomideData: finalQ221Data,
          q241_lenalidomideData: finalQ241Data,
          q231_lenalidomideData: finalQ231Data,
          q251_lenalidomideData: finalQ251Data,
          q242ABortezomibDoseFrequencyList: q242ABortezomibDoseFrequencyList,
          q232ABortezomibDoseFrequencyList: q232ABortezomibDoseFrequencyList,
          q252ABortezomibDoseFrequencyList: q252ABortezomibDoseFrequencyList,
        }));
      }
    } catch (e) {
      ToggleLoader(false);
    }
  }

  function MapBortezomibByPhase(bortezomibSource = [], phaseId, isSelected) {
    if (!isSelected && bortezomibSource?.length === 0) return [];

    const baseRow = {
      ...bortezomibDoseFrequencyRow,
      ndmmPhasesId: phaseId,
    };

    const filtered = bortezomibSource.filter((d) => d.ndmmPhasesId === phaseId);

    if (filtered.length === 0) {
      return [baseRow];
    }

    // Map existing data
    return filtered.map((item) => ({
      ...baseRow,

      ndmmBortezomibDosageBridgeId: item.ndmmBortezomibDosageBridgeId,
      ndmmTreatmentAgentId: item.ndmmTreatmentAgentId,

      doseFrequencyReceived: item.doseFrequencyReceived,
      doseFrequencyReceivedDate: item.doseFrequencyReceivedDate ?? "",
      doseFrequencyReceivedBefore: item.doseFrequencyReceivedBefore,
      doseFrequencyBeforeUnit: item.doseFrequencyBeforeUnit,
      doseFrequencyReceivedAfter: item.doseFrequencyReceivedAfter,
      doseFrequencyAfterUnit: item.doseFrequencyAfterUnit,
      doseFrequencyBeforeOthTxt: item.doseFrequencyBeforeOthTxt ?? "",
      doseFrequencyAfterOthTxt: item.doseFrequencyAfterOthTxt ?? "",
    }));
  }

  function MapLenalidomideByPhase(
    lenalidomideSource = [],
    phaseId,
    isSelected,
  ) {
    if (!isSelected && lenalidomideSource?.length === 0) return [];

    const baseRow = {
      ...dosageModificationRow,
      ndmmPhaseId: phaseId,
    };

    const filtered = lenalidomideSource.filter(
      (d) => d.ndmmphasesid === phaseId,
    );

    if (filtered.length === 0) {
      return [baseRow];
    }

    return filtered.map((item) => ({
      ...baseRow,
      dosageBridgeId: item.ndmmlenalidomidedosagebridgeid,
      doseStrengthReceivedRadio: item.dosestrengthreceived,
      doseStrengthReceivedDate: item.dosestrengthreceivedDate ?? null,
      doseStrengthBeforeRadio: item.dosestrengthreceivedbefore,
      doseStrengthBeforeUnit: item.dosestrengthbeforeunit ?? null,
      doseStrengthAfterRadio: item.dosestrengthreceivedafter,
      doseStrengthAfterUnit: item.dosestrengthafterunit ?? null,
    }));
  }

  async function ValidateForm() {
    let result = true;
    //Q21
    if (ndmmTreatmentCohortDetails.show_q21_q25) {
      if (isStringEmpty(ndmmTreatmentCohortDetails.q21_data)) {
        result = false;
        setHardErrList((prev) => ({
          ...prev,
          q21Empty: true,
        }));
      } else {
        setHardErrList((prev) => ({
          ...prev,
          q21Empty: false,
        }));
      }

      //Q21.1
      if (
        ndmmTreatmentCohortDetails.q21_1_CT ||
        ndmmTreatmentCohortDetails.q21_1_MT
      ) {
        if (
          ndmmTreatmentCohortDetails.q21_1_CT &&
          ndmmTreatmentCohortDetails.q23_agentData.length === 0
        ) {
          result = false;
          setHardErrList((prev) => ({
            ...prev,
            q23Empty: true,
          }));
        } else {
          setHardErrList((prev) => ({
            ...prev,
            q23Empty: false,
          }));
        }

        if (
          ndmmTreatmentCohortDetails.q21_1_MT &&
          ndmmTreatmentCohortDetails.q24_agentData.length === 0
        ) {
          result = false;
          setHardErrList((prev) => ({
            ...prev,
            q24Empty: true,
          }));
        } else {
          setHardErrList((prev) => ({
            ...prev,
            q24Empty: false,
          }));
        }
      }
    }

    //Q22 and Q25 - Check if the start date of any rows is same as index date

    if (
      ndmmTreatmentCohortDetails.show_q21_q25 &&
      !ndmmTreatmentCohortDetails.show_q25
    ) {
      // const isUnkSelectedq22 = ndmmTreatmentCohortDetails.q22_agentData.some(row => row.firstDateUnk === 1);
      // if (!isUnkSelectedq22) {
      let listOfDatesExceptUnk =
        ndmmTreatmentCohortDetails.q22_agentData.filter(
          (r) => r.firstDateUnk !== 1,
        );
      if (listOfDatesExceptUnk.length > 0) {
        const start_indexAnyq22 = listOfDatesExceptUnk.some(
          (row) => row.firstDate === ndmmTreatmentCohortDetails.ndmmIndexDate,
        );

        if (!start_indexAnyq22) {
          result = false;
          ndmmTreatmentCohortDetails.q22_agentData =
            ndmmTreatmentCohortDetails.q22_agentData.map((item) => {
              return {
                ...item,
                showColB_IdxDateError:
                  item.firstDate === "" ||
                  item.firstDate === null ||
                  item.firstDate === "Invalid Date" ||
                  !DateInRange(item.firstDate, dayjs("01-01-1920"), dayjs())
                    ? false
                    : true,
              };
            });
        } else {
          ndmmTreatmentCohortDetails.q22_agentData =
            ndmmTreatmentCohortDetails.q22_agentData.map((item) => {
              return { ...item, showColB_IdxDateError: false };
            });
        }
      }
      //}
    }

    if (
      (!ndmmTreatmentCohortDetails.show_q21_q25 &&
        ndmmTreatmentCohortDetails.show_q25_tie) ||
      (ndmmTreatmentCohortDetails.show_q21_q25 &&
        ndmmTreatmentCohortDetails.show_q25)
    ) {
      // const isUnkSelectedq25 = ndmmTreatmentCohortDetails.q25_agentData.some(row => row.firstDateUnk === 1);
      // if (!isUnkSelectedq25) {

      let listOfDatesExceptUnk =
        ndmmTreatmentCohortDetails.q25_agentData.filter(
          (r) => r.firstDateUnk !== 1,
        );
      if (listOfDatesExceptUnk.length > 0) {
        const start_indexAnyq25 = listOfDatesExceptUnk.some(
          (row) => row.firstDate === ndmmTreatmentCohortDetails.ndmmIndexDate,
        );

        if (!start_indexAnyq25) {
          result = false;
          ndmmTreatmentCohortDetails.q25_agentData =
            ndmmTreatmentCohortDetails.q25_agentData.map((item) => {
              return {
                ...item,
                showColB_IdxDateError:
                  item.firstDate === "" ||
                  item.firstDate === null ||
                  item.firstDate === "Invalid Date"
                    ? false
                    : true,
              };
            });
        } else {
          ndmmTreatmentCohortDetails.q25_agentData =
            ndmmTreatmentCohortDetails.q25_agentData.map((item) => {
              return { ...item, showColB_IdxDateError: false };
            });
        }
        // }
      }
    }

    let repeaterarray_q22 = ndmmTreatmentCohortDetails.q22_agentData;
    let repeaterarray_q23 = ndmmTreatmentCohortDetails.q23_agentData;
    let repeaterarray_q24 = ndmmTreatmentCohortDetails.q24_agentData;
    let repeaterarray_q25 = ndmmTreatmentCohortDetails.q25_agentData;

    // Q23 (consolidation) cannot be validated while an induction (Q22)
    // agent is still "No, medication ongoing at time of last encounter"
    // Q24 (maintenance) cannot be validated while an induction (Q22) or consolidation (Q23)
    // agent is still "No, medication ongoing at time of last encounter"
    const hasOngoingAgent = (list) =>
      (list || []).some((item) => item.discontinueAgent === 2);
    const isQ23BlockedByOngoingPhase =
      repeaterarray_q23.length > 0 && hasOngoingAgent(repeaterarray_q22);
    setHardErrList((prev) => ({
      ...prev,
      q23OngoingBlock: isQ23BlockedByOngoingPhase,
    }));
    if (isQ23BlockedByOngoingPhase) {
      result = false;
    }
    const validateQ23 =
      repeaterarray_q23.length > 0 && !isQ23BlockedByOngoingPhase;

    const isQ24BlockedByOngoingPhase =
      repeaterarray_q24.length > 0 &&
      (hasOngoingAgent(repeaterarray_q22) ||
        hasOngoingAgent(repeaterarray_q23));
    setHardErrList((prev) => ({
      ...prev,
      q24OngoingBlock: isQ24BlockedByOngoingPhase,
    }));
    if (isQ24BlockedByOngoingPhase) {
      result = false;
    }
    const validateQ24 =
      repeaterarray_q24.length > 0 && !isQ24BlockedByOngoingPhase;

    let resultPromise = [];
    if (
      ndmmTreatmentCohortDetails.show_q21_q25 &&
      !ndmmTreatmentCohortDetails.show_q25
    ) {
      const { isValid: isQ22ChainValid, updatedList: chainCheckedQ22List } =
        CheckQ22FullDateChain(repeaterarray_q22);
      repeaterarray_q22 = chainCheckedQ22List;
      setNDMMTreatmentCohortDetails((prev) => ({
        ...prev,
        q22_agentData: chainCheckedQ22List,
      }));

      if (!isQ22ChainValid) {
        result = false;
      }

      if (validateQ23) {
        const { isValid: isQ23ChainValid, updatedList: chainCheckedQ23List } =
          CheckQ23FullDateChain(repeaterarray_q23, repeaterarray_q22);
        repeaterarray_q23 = chainCheckedQ23List;
        setNDMMTreatmentCohortDetails((prev) => ({
          ...prev,
          q23_agentData: chainCheckedQ23List,
        }));

        if (!isQ23ChainValid) {
          result = false;
        }
      } else {
        repeaterarray_q23 = repeaterarray_q23.map((row) => ({
          ...row,
          q23ChainErr: false,
        }));
        setNDMMTreatmentCohortDetails((prev) => ({
          ...prev,
          q23_agentData: repeaterarray_q23,
        }));
      }

      if (validateQ24) {
        const { isValid: isQ24ChainValid, updatedList: chainCheckedQ24List } =
          CheckQ24FullDateChain(
            repeaterarray_q24,
            repeaterarray_q22,
            repeaterarray_q23,
          );
        repeaterarray_q24 = chainCheckedQ24List;
        setNDMMTreatmentCohortDetails((prev) => ({
          ...prev,
          q24_agentData: chainCheckedQ24List,
        }));

        if (!isQ24ChainValid) {
          result = false;
        }
      } else {
        repeaterarray_q24 = repeaterarray_q24.map((row) => ({
          ...row,
          q24ChainErr: false,
        }));
        setNDMMTreatmentCohortDetails((prev) => ({
          ...prev,
          q24_agentData: repeaterarray_q24,
        }));
      }

      if (
        ndmmTreatmentCohortDetails.q21_1_CT &&
        validateQ23 &&
        ndmmTreatmentCohortDetails.q21_1_MT &&
        validateQ24
      ) {
        resultPromise = await Promise.all([
          ValidateRepeater(repeaterarray_q22),
          ValidateRepeater(repeaterarray_q23),
          ValidateRepeater(repeaterarray_q24),
        ]);
      } else if (
        (ndmmTreatmentCohortDetails.q21_1_CT &&
          validateQ23 &&
          !ndmmTreatmentCohortDetails.q21_1_MT) ||
        (ndmmTreatmentCohortDetails.q21_1_CT &&
          validateQ23 &&
          ndmmTreatmentCohortDetails.q21_1_MT &&
          !validateQ24)
      ) {
        resultPromise = await Promise.all([
          ValidateRepeater(repeaterarray_q22),
          ValidateRepeater(repeaterarray_q23),
        ]);
      } else if (
        (ndmmTreatmentCohortDetails.q21_1_MT &&
          validateQ24 &&
          !ndmmTreatmentCohortDetails.q21_1_CT) ||
        (ndmmTreatmentCohortDetails.q21_1_MT &&
          validateQ24 &&
          ndmmTreatmentCohortDetails.q21_1_CT &&
          !validateQ23)
      ) {
        resultPromise = await Promise.all([
          ValidateRepeater(repeaterarray_q22),
          ValidateRepeater(repeaterarray_q24),
        ]);
      } else {
        resultPromise = await Promise.all([
          ValidateRepeater(repeaterarray_q22),
        ]);
      }
    } else if (
      ndmmTreatmentCohortDetails.show_q25 ||
      ndmmTreatmentCohortDetails.show_q25_tie
    ) {
      const { isValid: isChainValid, updatedList: chainCheckedQ25List } =
        CheckQ25FullDateChain(repeaterarray_q25);
      repeaterarray_q25 = chainCheckedQ25List;
      setNDMMTreatmentCohortDetails((prev) => ({
        ...prev,
        q25_agentData: chainCheckedQ25List,
      }));

      if (!isChainValid) {
        result = false;
      }

      resultPromise = await Promise.all([ValidateRepeater(repeaterarray_q25)]);
    }

    if (resultPromise.includes(false)) {
      result = false;
    }

    if (isNewEcrfA) {
      //Q22.2A and Q24.2A
      const bortezomibValidationConfigs = [
        {
          isSelected:
            isBortezomibSelectedInQ22 &&
            ndmmTreatmentCohortDetails.show_q21_q25 === true &&
            !ndmmTreatmentCohortDetails.show_q25,
          list: ndmmTreatmentCohortDetails.q22ABortezomibDoseFrequencyList,
          phaseId: NDMMPhasesId.InductionTherapy,
        },
        {
          isSelected:
            isBortezomibSelectedInQ24 &&
            ndmmTreatmentCohortDetails.show_q21_q25 === true &&
            !ndmmTreatmentCohortDetails.show_q25 &&
            validateQ24,
          list: ndmmTreatmentCohortDetails.q242ABortezomibDoseFrequencyList,
          phaseId: NDMMPhasesId.MaintenanceTherapy,
        },
        {
          isSelected:
            isBortezomibSelectedInQ23 &&
            ndmmTreatmentCohortDetails.show_q21_q25 === true &&
            !ndmmTreatmentCohortDetails.show_q25 &&
            validateQ23,
          list: ndmmTreatmentCohortDetails.q232ABortezomibDoseFrequencyList,
          phaseId: NDMMPhasesId.ConsolidationTherapy,
        },
        {
          isSelected:
            isBortezomibSelectedInQ25 &&
            (ndmmTreatmentCohortDetails.show_q25 === true ||
              ndmmTreatmentCohortDetails.show_q25_tie === true),
          list: ndmmTreatmentCohortDetails.q252ABortezomibDoseFrequencyList,
          phaseId: NDMMPhasesId.OtherTherapy,
        },
      ];

      for (const config of bortezomibValidationConfigs) {
        if (config.isSelected && config.list?.length) {
          const isValid = await ValidateBortezomibDoseFrequency(
            config.list,
            config.phaseId,
          );

          if (!isValid) {
            result = false;
          }
        }
      }

      if (
        ndmmTreatmentCohortDetails.show_q21_q25 === true &&
        !ndmmTreatmentCohortDetails.show_q25 &&
        IsLenalidomideSelectedInQ22State &&
        ndmmTreatmentCohortDetails.q221_lenalidomideData &&
        ndmmTreatmentCohortDetails.q221_lenalidomideData.length > 0
      ) {
        const lenalidomideValidation = await ValidateLenalidomideDoseStrength(
          ndmmTreatmentCohortDetails.q221_lenalidomideData,
          NDMMPhasesId.InductionTherapy, // Phase ID for Induction
        );

        if (!lenalidomideValidation) {
          result = false;
        }
      }
      // Q24.1.A Validation (Maintenance) - NEW
      if (
        ndmmTreatmentCohortDetails.show_q21_q25 === true &&
        !ndmmTreatmentCohortDetails.show_q25 &&
        IsLenalidomideSelectedInQ24State &&
        ndmmTreatmentCohortDetails.q21_1_MT &&
        validateQ24 &&
        ndmmTreatmentCohortDetails.q241_lenalidomideData &&
        ndmmTreatmentCohortDetails.q241_lenalidomideData.length > 0
      ) {
        const lenalidomideQ24Validation =
          await ValidateLenalidomideDoseStrength(
            ndmmTreatmentCohortDetails.q241_lenalidomideData,
            NDMMPhasesId.MaintenanceTherapy, // Phase ID for Maintenance
          );

        if (!lenalidomideQ24Validation) {
          result = false;
        }
      }

      if (
        ndmmTreatmentCohortDetails.show_q21_q25 === true &&
        !ndmmTreatmentCohortDetails.show_q25 &&
        IsLenalidomideSelectedInQ23State &&
        ndmmTreatmentCohortDetails.q21_1_CT &&
        validateQ23 &&
        ndmmTreatmentCohortDetails.q231_lenalidomideData &&
        ndmmTreatmentCohortDetails.q231_lenalidomideData.length > 0
      ) {
        const lenalidomideQ23Validation =
          await ValidateLenalidomideDoseStrength(
            ndmmTreatmentCohortDetails.q231_lenalidomideData,
            NDMMPhasesId.ConsolidationTherapy, // phaseId = 2 (Consolidation)
          );
        if (!lenalidomideQ23Validation) {
          result = false;
        }
      }

      if (
        (ndmmTreatmentCohortDetails.show_q25 === true ||
          ndmmTreatmentCohortDetails.show_q25_tie === true) &&
        IsLenalidomideSelectedInQ25State &&
        ndmmTreatmentCohortDetails.q251_lenalidomideData &&
        ndmmTreatmentCohortDetails.q251_lenalidomideData.length > 0
      ) {
        const lenalidomideQ25Validation =
          await ValidateLenalidomideDoseStrength(
            ndmmTreatmentCohortDetails.q251_lenalidomideData,
            NDMMPhasesId.OtherTherapy, // phaseId = 4 (TIE)
          );
        if (!lenalidomideQ25Validation) {
          result = false;
        }
      }
    }

    return result;
  }


  function ComputeDoseModificationBounds(phaseId, agentData) {
    const getEarliestDate = (...dates) => {
      return (
        dates
          .flat()
          .filter((d) => d && IsDateValid(d))
          .map((d) => new Date(d))
          .sort((a, b) => a - b)[0] || null
      );
    };

    const getLatestDate = (...dates) => {
      return (
        dates
          .flat()
          .filter((d) => d && IsDateValid(d))
          .map((d) => new Date(d))
          .sort((a, b) => b - a)[0] || null
      );
    };

    const details = ndmmTreatmentCohortDetails ?? {};

    const firstAdmin = !isStringEmpty(agentData?.firstDate)
      ? agentData?.firstDate
      : details?.ndmmIndexDate;
    const lastAdmin = agentData?.lastDate;

    let earliestEnd = null;
    // Additional lower-bound floor beyond firstAdmin/NDMM index date, per phase:
    // MAX(latest start date, latest end date) of the prior phase(s)' first agent row
    let extraLowerBound = null;

    if (phaseId === NDMMPhasesId.InductionTherapy) {
      // For Induction (Q22): earliest of last admin, first consolidation, first maintenance, earliest RRMM LOT, or EOF
      const q23Dates = details.q23_agentData?.map((x) => x.firstDate) || [];
      const q24Dates = details.q24_agentData?.map((x) => x.firstDate) || [];

      earliestEnd = getEarliestDate(
        lastAdmin,
        getEarliestDate(q23Dates),
        getEarliestDate(q24Dates),
        earliestRRMMDate,
        details.endOfFollowUp,
      );
    } else if (phaseId === NDMMPhasesId.ConsolidationTherapy) {
      // For Consolidation (Q23): earliest of last admin, first maintenance, earliest RRMM LOT, or EOF
      const q24Dates = details.q24_agentData?.map((x) => x.firstDate) || [];

      earliestEnd = getEarliestDate(
        lastAdmin,
        getEarliestDate(q24Dates),
        earliestRRMMDate,
        details.endOfFollowUp,
      );

      // Lower bound: MAX(latest 1L induction agent end date, latest 1L induction agent start date)
      // Only the first row of Q22's agent list is used
      const q22FirstRow = details.q22_agentData?.[0];
      extraLowerBound = getLatestDate(
        q22FirstRow?.firstDate,
        q22FirstRow?.lastDate,
      );
    } else if (phaseId === NDMMPhasesId.MaintenanceTherapy) {
      // For Maintenance (Q24): earliest of last admin, earliest RRMM LOT, or EOF
      earliestEnd = getEarliestDate(
        lastAdmin,
        earliestRRMMDate,
        details.endOfFollowUp,
      );

      // Lower bound: MAX(latest 1L consolidation end/start, latest 1L induction end/start)
      // Only the first row of each phase's agent list is used
      const q22FirstRow = details.q22_agentData?.[0];
      const q23FirstRow = details.q23_agentData?.[0];
      extraLowerBound = getLatestDate(
        q22FirstRow?.firstDate,
        q22FirstRow?.lastDate,
        q23FirstRow?.firstDate,
        q23FirstRow?.lastDate,
      );
    } else if (phaseId === NDMMPhasesId.OtherTherapy) {
      // For TIE (Q25): earliest of last admin, earliest RRMM LOT, or EOF
      earliestEnd = getEarliestDate(
        lastAdmin,
        earliestRRMMDate,
        details.endOfFollowUp,
      );
    }

    const firstAdminDate =
      firstAdmin && IsDateValid(firstAdmin) ? new Date(firstAdmin) : null;
    const earliestEndDate = earliestEnd ? new Date(earliestEnd) : null;
    const extraLowerBoundDate = extraLowerBound
      ? new Date(extraLowerBound)
      : null;
    const ndmmIndexDateObj =
      details?.ndmmIndexDate && IsDateValid(details.ndmmIndexDate)
        ? new Date(details.ndmmIndexDate)
        : null;

    return { firstAdminDate, earliestEndDate, extraLowerBoundDate, ndmmIndexDateObj };
  }

  async function ValidateBortezomibDoseFrequency(list = [], phaseId) {
    let isValid = true;

    if (!Array.isArray(list) || !list.length) {
      return true;
    }

    const details = ndmmTreatmentCohortDetails ?? {};

    // Get agent data
    const agentData =
      phaseId === NDMMPhasesId.InductionTherapy
        ? details.q22_agentData?.find(
            (x) => x.agentName === NDMMCohortAgent.Bortezomib,
          )
        : phaseId === NDMMPhasesId.MaintenanceTherapy
          ? details.q24_agentData?.find(
              (x) => x.agentName === NDMMCohortAgentWithSuperScript.Bortezomib,
            )
          : phaseId === NDMMPhasesId.ConsolidationTherapy
            ? details.q23_agentData?.find(
                (x) =>
                  x.agentName === NDMMCohortAgentWithSuperScript.Bortezomib,
              )
            : phaseId === NDMMPhasesId.OtherTherapy
              ? details.q25_agentData?.find(
                  (x) => x.agentName === NDMMCohortAgent.Bortezomib,
                )
              : null;

    if (!agentData) return true;

    const {
      firstAdminDate,
      earliestEndDate,
      extraLowerBoundDate,
      ndmmIndexDateObj,
    } = ComputeDoseModificationBounds(phaseId, agentData);

    const updatedList = list.map((row) => {
      const updatedRow = { ...row };

      // Reset all errors
      const errorKeys = [
        "bortezomibDoseFreqEmptyError",
        "bortezomibDoseFreqDateEmptyError",
        "bortezomibDoseFreqDateInvalidError",
        "bortezomibDoseFreqDateOFBError",
        "bortezomibDoseFreqBeforeEmptyError",
        "bortezomibDoseFreqAfterEmptyError",
        "bortezomibDoseFreqBeforeUnitEmptyError",
        "bortezomibDoseFreqAfterWeekEmptyError",
        "bortezomibDoseFreqBeforeRangeError",
        "bortezomibDoseFreqAfterRangeError",
        "bortezomibDoseFreqBeforeUnitSameError",
        "bortezomibDoseFreqAfterUnitSameError",
      ];

      errorKeys.forEach((key) => {
        updatedRow[key] = false;
      });

      /* ---------- Column A ---------- */

      if (!row.doseFrequencyReceived) {
        updatedRow.bortezomibDoseFreqEmptyError = true;
        isValid = false;
      }

      if (row.doseFrequencyReceived === 2) {
        if (isStringEmpty(row.doseFrequencyReceivedDate)) {
          updatedRow.bortezomibDoseFreqDateEmptyError = true;
          isValid = false;
        } else if (!IsDateValid(row.doseFrequencyReceivedDate)) {
          updatedRow.bortezomibDoseFreqDateInvalidError = true;
          isValid = false;
        } else {
          const current = new Date(row.doseFrequencyReceivedDate);
          const earliestRRMMDateObj = earliestRRMMDate
            ? new Date(earliestRRMMDate)
            : null;
          if (
            (firstAdminDate && current < firstAdminDate) ||
            (ndmmIndexDateObj && current < ndmmIndexDateObj) ||
            (extraLowerBoundDate && current < extraLowerBoundDate) ||
            (earliestRRMMDateObj && current > earliestRRMMDateObj) ||
            (earliestEndDate && current > earliestEndDate)
          ) {
            updatedRow.bortezomibDoseFreqDateOFBError = true;
            isValid = false;
          }
        }
      }

      if (SHOW_FREQUENCY_VALUES.includes(row.doseFrequencyReceived)) {
        /* ---------- Column B ---------- */

        const beforeVal = row.doseFrequencyBeforeUnit;

        if (!row.doseFrequencyReceivedBefore) {
          updatedRow.bortezomibDoseFreqBeforeEmptyError = true;
          isValid = false;
        } else if (
          row.doseFrequencyReceivedBefore === 3 &&
          isStringEmpty(row.doseFrequencyBeforeOthTxt)
        ) {
          updatedRow.bortezomibDoseFreqBeforeOthTxtEmptyError = true;
          isValid = false;
        } else if (
          row.doseFrequencyReceivedBefore !== 99 &&
          row.doseFrequencyReceivedBefore !== 3
        ) {
          if (
            isStringEmpty(row.doseFrequencyBeforeUnit) &&
            row.doseFrequencyBeforeUnit !== 0
          ) {
            updatedRow.bortezomibDoseFreqBeforeUnitEmptyError = true;
            isValid = false;
          } else if (
            !Number.isInteger(beforeVal) ||
            beforeVal < 1 ||
            beforeVal > 10
          ) {
            updatedRow.bortezomibDoseFreqBeforeRangeError = true;
            isValid = false;
          }
        }

        /* ---------- Column C ---------- */

        const afterVal = row.doseFrequencyAfterUnit;

        if (!row.doseFrequencyReceivedAfter) {
          updatedRow.bortezomibDoseFreqAfterEmptyError = true;
          isValid = false;
        } else if (
          row.doseFrequencyReceivedAfter === 3 &&
          isStringEmpty(row.doseFrequencyAfterOthTxt)
        ) {
          updatedRow.bortezomibDoseFreqAfterOthTxtEmptyError = true;
          isValid = false;
        } else if (
          row.doseFrequencyReceivedAfter !== 99 &&
          row.doseFrequencyReceivedAfter !== 3
        ) {
          if (
            isStringEmpty(row.doseFrequencyAfterUnit) &&
            row.doseFrequencyAfterUnit !== 0
          ) {
            updatedRow.bortezomibDoseFreqAfterWeekEmptyError = true;
            isValid = false;
          } else if (
            !Number.isInteger(afterVal) ||
            afterVal < 1 ||
            afterVal > 10
          ) {
            updatedRow.bortezomibDoseFreqAfterRangeError = true;
            isValid = false;
          }
        }

        /* ---------- Same Unit Check ---------- */

        if (
          row.doseFrequencyBeforeUnit &&
          row.doseFrequencyAfterUnit &&
          row.doseFrequencyBeforeUnit === row.doseFrequencyAfterUnit &&
          row.doseFrequencyReceivedAfter !== 99 &&
          row.doseFrequencyReceivedAfter !== 3 &&
          row.doseFrequencyReceivedBefore !== 99 &&
          row.doseFrequencyReceivedBefore !== 3 &&
          beforeVal === afterVal
        ) {
          updatedRow.bortezomibDoseFreqBeforeUnitSameError = true;
          updatedRow.bortezomibDoseFreqAfterUnitSameError = true;
          isValid = false;
        }
      }

      return updatedRow;
    });

    // Update state
    if (phaseId === NDMMPhasesId.InductionTherapy) {
      setNDMMTreatmentCohortDetails((prev) => ({
        ...prev,
        q22ABortezomibDoseFrequencyList: updatedList,
      }));
    } else if (phaseId === NDMMPhasesId.MaintenanceTherapy) {
      setNDMMTreatmentCohortDetails((prev) => ({
        ...prev,
        q242ABortezomibDoseFrequencyList: updatedList,
      }));
    } else if (phaseId === NDMMPhasesId.ConsolidationTherapy) {
      setNDMMTreatmentCohortDetails((prev) => ({
        ...prev,
        q232ABortezomibDoseFrequencyList: updatedList,
      }));
    } else if (phaseId === NDMMPhasesId.OtherTherapy) {
      setNDMMTreatmentCohortDetails((prev) => ({
        ...prev,
        q252ABortezomibDoseFrequencyList: updatedList,
      }));
    }

    return isValid;
  }

  async function ValidateLenalidomideDoseStrength(list, phaseId) {
    let isValid = true;

    // Get agent data based on phase
    let agentData;
    if (phaseId === NDMMPhasesId.InductionTherapy) {
      agentData = ndmmTreatmentCohortDetails.q22_agentData?.find(
        (x) => x.agentName === NDMMCohortAgent.Lenalidomide,
      );
    } else if (phaseId === NDMMPhasesId.ConsolidationTherapy) {
      agentData = ndmmTreatmentCohortDetails.q23_agentData?.find(
        (x) => x.agentName === NDMMCohortAgentWithSuperScript.Lenalidomide,
      );
    } else if (phaseId === NDMMPhasesId.MaintenanceTherapy) {
      agentData = ndmmTreatmentCohortDetails.q24_agentData?.find(
        (x) => x.agentName === NDMMCohortAgentWithSuperScript.Lenalidomide,
      );
    } else if (phaseId === NDMMPhasesId.OtherTherapy) {
      agentData = ndmmTreatmentCohortDetails.q25_agentData?.find(
        (x) => x.agentName === NDMMCohortAgent.Lenalidomide,
      );
    }

    const {
      firstAdminDate,
      earliestEndDate,
      extraLowerBoundDate,
      ndmmIndexDateObj,
    } = ComputeDoseModificationBounds(phaseId, agentData);

    const updatedList = list.map((row) => {
      const updatedRow = { ...row };

      // Clear all errors
      updatedRow.showColAError = false;
      updatedRow.showColADateEmptyError = false;
      updatedRow.showColAInvalidDate = false;
      updatedRow.showColABeforeFirstDateError = false;
      updatedRow.showColAAfterLastDateError = false;
      updatedRow.showColBError = false;
      updatedRow.showColBValueError = false;
      updatedRow.showColBRangeError = false;
      updatedRow.showColBSameValueError = false;
      updatedRow.showColCError = false;
      updatedRow.showColCValueError = false;
      updatedRow.showColCRangeError = false;
      updatedRow.showColCSameValueError = false;

      // Column A Validation: Date of modification
      if (!row.doseStrengthReceivedRadio) {
        updatedRow.showColAError = true;
        isValid = false;
      }

      if (row.doseStrengthReceivedRadio === 2) {
        if (isStringEmpty(row.doseStrengthReceivedDate)) {
          updatedRow.showColADateEmptyError = true;
          isValid = false;
        } else if (!IsDateValid(row.doseStrengthReceivedDate)) {
          updatedRow.showColAInvalidDate = true;
          isValid = false;
        } else {
          const modificationDate = new Date(row.doseStrengthReceivedDate);

          if (firstAdminDate && modificationDate < firstAdminDate) {
            updatedRow.showColABeforeFirstDateError = true;
            isValid = false;
          }

          if (ndmmIndexDateObj && modificationDate < ndmmIndexDateObj) {
            updatedRow.showColABeforeFirstDateError = true;
            isValid = false;
          }

          if (
            extraLowerBoundDate &&
            modificationDate < extraLowerBoundDate
          ) {
            updatedRow.showColABeforeFirstDateError = true;
            isValid = false;
          }

          if (earliestEndDate && modificationDate > earliestEndDate) {
            updatedRow.showColAAfterLastDateError = true;
            isValid = false;
          }
          const earliestRRMMDateObj = earliestRRMMDate
            ? new Date(earliestRRMMDate)
            : null;
          if (earliestRRMMDateObj && modificationDate > earliestRRMMDateObj) {
            updatedRow.showColAAfterLastDateError = true;
            isValid = false;
          }
        }
      }

      if (SHOW_FREQUENCY_VALUES.includes(row.doseStrengthReceivedRadio)) {
        // Column B Validation: Dose strength BEFORE modification
        if (!row.doseStrengthBeforeRadio) {
          updatedRow.showColBError = true;
          isValid = false;
        } else if (row.doseStrengthBeforeRadio !== 99) {
          if (isStringEmpty(row.doseStrengthBeforeUnit)) {
            updatedRow.showColBValueError = true;
            isValid = false;
          } else {
            const beforeVal = Number(row.doseStrengthBeforeUnit);

            if (beforeVal < 0.01 || beforeVal > 50) {
              updatedRow.showColBRangeError = true;
              isValid = false;
            }
          }
        }

        // Column C Validation: Dose strength AFTER modification
        if (!row.doseStrengthAfterRadio) {
          updatedRow.showColCError = true;
          isValid = false;
        } else if (row.doseStrengthAfterRadio !== 99) {
          if (isStringEmpty(row.doseStrengthAfterUnit)) {
            updatedRow.showColCValueError = true;
            isValid = false;
          } else {
            const afterVal = Number(row.doseStrengthAfterUnit);

            if (afterVal < 0.01 || afterVal > 50) {
              updatedRow.showColCRangeError = true;
              isValid = false;
            }
          }
        }
        // Cross-validation
        if (
          row.doseStrengthBeforeRadio &&
          row.doseStrengthAfterRadio &&
          row.doseStrengthBeforeRadio === row.doseStrengthAfterRadio &&
          row.doseStrengthBeforeRadio !== 99 &&
          row.doseStrengthAfterUnit
        ) {
          const beforeVal = Number(row.doseStrengthBeforeUnit);
          const afterVal = Number(row.doseStrengthAfterUnit);

          if (beforeVal === afterVal) {
            updatedRow.showColBSameValueError = true;
            updatedRow.showColCSameValueError = true;
            isValid = false;
          }
        }
      }

      return updatedRow;
    });

    // Update state based on phase
    if (phaseId === NDMMPhasesId.InductionTherapy) {
      setNDMMTreatmentCohortDetails((prev) => ({
        ...prev,
        q221_lenalidomideData: updatedList,
      }));
    } else if (phaseId === NDMMPhasesId.ConsolidationTherapy) {
      setNDMMTreatmentCohortDetails((prev) => ({
        ...prev,
        q231_lenalidomideData: updatedList,
      }));
    } else if (phaseId === NDMMPhasesId.MaintenanceTherapy) {
      setNDMMTreatmentCohortDetails((prev) => ({
        ...prev,
        q241_lenalidomideData: updatedList,
      }));
    } else if (phaseId === NDMMPhasesId.OtherTherapy) {
      setNDMMTreatmentCohortDetails((prev) => ({
        ...prev,
        q251_lenalidomideData: updatedList,
      }));
    }

    return isValid;
  }

  const getValue = (repeaterarray) => {
    if (repeaterarray.phaseid === 4) return 4000;
    if (repeaterarray.phaseid === 1) {
      switch (repeaterarray.agentName) {
        case NDMMCohortAgent.Daratumumab:
          return 2000;
        case NDMMCohortAgent.Bortezomib:
          return 20;
        case NDMMCohortAgent.Lenalidomide:
          return 50;
        default:
          return 4000;
      }
    }
    return 0; // or some fallback value
  };

  const IsQ25ChainViolated = (steps) => {
    const present = steps.filter((s) => !isStringEmpty(s.date));
    for (let i = 0; i < present.length - 1; i++) {
      if (IsDateAfter(present[i].date, present[i + 1].date)) {
        return true;
      }
    }
    return false;
  };

  // Q25 - Date of initial MM diagnosis ≤ NDMM index date ≤ 1L agent start date ≤ 1L agent end date ≤ end of follow up
  const CheckQ25FullDateChain = (list) => {
    let isValid = true;

    const updatedList = (list || []).map((row) => {
      const steps = [
        {
          label: "date of initial MM diagnosis",
          date: ndmmTreatmentCohortDetails.initialMMDiagnosisDate,
        },
        { label: "NDMM index date", date: ndmmTreatmentCohortDetails.ndmmIndexDate },
        { label: "1L agent start date", date: row.firstDate },
        { label: "1L agent end date", date: row.lastDate },
        { label: "end of follow-up date", date: ndmmTreatmentCohortDetails.endOfFollowUp },
      ];

      const isViolated = IsQ25ChainViolated(steps);

      if (isViolated) {
        isValid = false;
      }
      return { ...row, q25ChainErr: isViolated };
    });

    return { isValid, updatedList };
  };

  // Q22 - Date of initial MM diagnosis ≤ NDMM index date ≤ 1L induction agent start date ≤ 1L induction agent end date ≤ end of follow up
  const CheckQ22FullDateChain = (list) => {
    let isValid = true;

    const updatedList = (list || []).map((row) => {
      const steps = [
        {
          label: "date of initial MM diagnosis",
          date: ndmmTreatmentCohortDetails.initialMMDiagnosisDate,
        },
        { label: "NDMM index date", date: ndmmTreatmentCohortDetails.ndmmIndexDate },
        { label: "1L induction agent start date", date: row.firstDate },
        { label: "1L induction agent end date", date: row.lastDate },
        { label: "end of follow-up date", date: ndmmTreatmentCohortDetails.endOfFollowUp },
      ];

      const isViolated = IsQ25ChainViolated(steps);

      if (isViolated) {
        isValid = false;
      }
      return { ...row, q25ChainErr: isViolated };
    });

    return { isValid, updatedList };
  };

  // Q23 - NDMM index date ≤ latest 1L induction agent end date ≤ 1L consolidation agent start date
  const CheckQ23FullDateChain = (list, inductionList) => {
    let isValid = true;

    let maxInductionLastDate = null;
    const listOfILastDatesExceptUnk = (inductionList || []).filter(
      (item) =>
        item.lastDate !== null &&
        item.lastDate !== "" &&
        item.lastDate !== "Invalid Date",
    );
    if (listOfILastDatesExceptUnk.length > 0) {
      maxInductionLastDate = getMaxLastDate(listOfILastDatesExceptUnk);
    }

    const updatedList = (list || []).map((row) => {
      const steps = [
        { label: "NDMM index date", date: ndmmTreatmentCohortDetails.ndmmIndexDate },
        {
          label: "latest 1L induction agent end date",
          date: maxInductionLastDate,
        },
        { label: "1L consolidation agent start date", date: row.firstDate },
      ];

      const isViolated = IsQ25ChainViolated(steps);

      if (isViolated) {
        isValid = false;
      }
      return { ...row, q23ChainErr: isViolated };
    });

    return { isValid, updatedList };
  };

  // Q24 - NDMM index date ≤ latest 1L induction agent end date ≤ latest 1L consolidation agent end date ≤ 1L maintenance agent start date
  const CheckQ24FullDateChain = (list, inductionList, consolidationList) => {
    let isValid = true;

    let maxInductionLastDate = null;
    const listOfILastDatesExceptUnk = (inductionList || []).filter(
      (item) =>
        item.lastDate !== null &&
        item.lastDate !== "" &&
        item.lastDate !== "Invalid Date",
    );
    if (listOfILastDatesExceptUnk.length > 0) {
      maxInductionLastDate = getMaxLastDate(listOfILastDatesExceptUnk);
    }

    let maxConsolidationLastDate = null;
    const listOfCLastDatesExceptUnk = (consolidationList || []).filter(
      (item) =>
        item.lastDate !== null &&
        item.lastDate !== "" &&
        item.lastDate !== "Invalid Date",
    );
    if (listOfCLastDatesExceptUnk.length > 0) {
      maxConsolidationLastDate = getMaxLastDate(listOfCLastDatesExceptUnk);
    }

    const updatedList = (list || []).map((row) => {
      const steps = [
        { label: "NDMM index date", date: ndmmTreatmentCohortDetails.ndmmIndexDate },
        {
          label: "latest 1L induction agent end date",
          date: maxInductionLastDate,
        },
        {
          label: "latest 1L consolidation agent end date",
          date: maxConsolidationLastDate,
        },
        { label: "1L maintenance agent start date", date: row.firstDate },
      ];

      const isViolated = IsQ25ChainViolated(steps);

      if (isViolated) {
        isValid = false;
      }
      return { ...row, q24ChainErr: isViolated };
    });

    return { isValid, updatedList };
  };

  async function ValidateRepeater(list) {
    // Your asynchronous processing logic for the list goes here
    const promises = list.map((item) => ValidateList(item));
    const results = await Promise.all(promises);
    return !results.includes(false);
  }

  async function ValidateList(item) {
    // Your asynchronous processing logic for an individual item
    return new Promise((resolve) => {
      setTimeout(() => {
        const isValid = ValidateRepeaterData(item);
        resolve(isValid);
      }, 1000); // Simulate async work
    });
  }

  async function ValidateRepeaterData(repeaterarray) {
    let result = true;

    //Q22 a
    if (
      isStringEmpty(repeaterarray.agentName) ||
      repeaterarray.agentName === null
    ) {
      result = false;
      repeaterarray.showColAError = true;
    } else {
      repeaterarray.showColAError = false;

      if (
        repeaterarray.agentName.includes("Other") &&
        (repeaterarray.agentOtherValue === null ||
          repeaterarray.agentOtherValue === "")
      ) {
        result = false;
        repeaterarray.showColAOthError = true;
      } else {
        if (repeaterarray.agentName.includes("Other")) {
          const enteredValue = repeaterarray.agentOtherValue
            ? repeaterarray.agentOtherValue.trim().toLowerCase()
            : "";

          //check if Other text has same value as the agent dropdown or same as any other text from the list, display error
          if (repeaterarray.phaseid === 2) {
            let savedAgentList = ndmmTreatmentCohortDetails.q23_agentList;

            let unsavedAgentList = ndmmTreatmentCohortDetails.q23_agentData;

            // Count the occurrences of the entered value in the unsaved agent list
            const unsavedOtherTextCount = unsavedAgentList.reduce(
              (count, agent) => {
                const agentOtherValue = agent.agentOtherValue
                  ? agent.agentOtherValue.trim().toLowerCase()
                  : "";
                const agentName = agent.agentName
                  ? agent.agentName.trim().toLowerCase()
                  : "";
                if (
                  agentOtherValue === enteredValue ||
                  agentName === enteredValue
                ) {
                  return count + 1;
                }
                return count;
              },
              0,
            );

            const otherTextExist = savedAgentList.some(
              (agent) => agent.agentName.trim().toLowerCase() === enteredValue,
            );

            if (otherTextExist || unsavedOtherTextCount > 1) {
              result = false;
              repeaterarray.showColAOthDupError = true;
            } else {
              repeaterarray.showColAOthDupError = false;
            }
          }

          if (repeaterarray.phaseid === 3) {
            let savedAgentList = ndmmTreatmentCohortDetails.q24_agentList;

            let unsavedAgentList = ndmmTreatmentCohortDetails.q24_agentData;

            // Count the occurrences of the entered value in the unsaved agent list
            const unsavedOtherTextCount = unsavedAgentList.reduce(
              (count, agent) => {
                const agentOtherValue = agent.agentOtherValue
                  ? agent.agentOtherValue.trim().toLowerCase()
                  : "";
                const agentName = agent.agentName
                  ? agent.agentName.trim().toLowerCase()
                  : "";
                if (
                  agentOtherValue === enteredValue ||
                  agentName === enteredValue
                ) {
                  return count + 1;
                }
                return count;
              },
              0,
            );

            const otherTextExist = savedAgentList.some(
              (agent) => agent.agentName.trim().toLowerCase() === enteredValue,
            );

            if (otherTextExist || unsavedOtherTextCount > 1) {
              result = false;
              repeaterarray.showColAOthDupError = true;
            } else {
              repeaterarray.showColAOthDupError = false;
            }
          }
        } else {
          repeaterarray.showColAOthDupError = false;
        }

        repeaterarray.showColAOthError = false;
      }
    }

    //Q22 b
    const { firstDate, firstDateRadio, firstDateUnk } = repeaterarray;

    // Reset errors
    repeaterarray.showColBError = false;
    repeaterarray.showColBInvalidDate = false;

    const isColBDateMissing =
      isStringEmpty(firstDate) &&
      isStringEmpty(firstDateRadio) &&
      isStringEmpty(firstDateUnk);

    if (isColBDateMissing) {
      repeaterarray.showColBError = true;
      result = false;
    } else if (firstDateRadio === 1) {
      const parsedDate = dayjs(firstDate);

      if (isStringEmpty(firstDate)) {
        repeaterarray.showColBError = true;
        result = false;
      } else if (!parsedDate.isValid()) {
        repeaterarray.showColBInvalidDate = true;
        result = false;
      } else if (!DateInRange(parsedDate, dayjs("01-01-1920"), dayjs())) {
        repeaterarray.showColBInvalidDate = true;
        result = false;
      }
    }

    //Q22 c
    const { lastDate, lastDateRadio, lastDateUnk } = repeaterarray;

    // Reset errors
    repeaterarray.showColCError = false;
    repeaterarray.showColCInvalidDate = false;

    const isColCDateMissing =
      isStringEmpty(lastDate) &&
      isStringEmpty(lastDateRadio) &&
      isStringEmpty(lastDateUnk);

    if (isColCDateMissing) {
      repeaterarray.showColCError = true;
      result = false;
    } else if (lastDateRadio === 1) {
      if (isStringEmpty(lastDate)) {
        repeaterarray.showColCError = true;
        result = false;
      } else {
        const parsedDate = dayjs(lastDate);

        if (!parsedDate.isValid()) {
          repeaterarray.showColCInvalidDate = true;
          result = false;
        } else if (!DateInRange(parsedDate, dayjs("01-01-1920"), dayjs())) {
          repeaterarray.showColCInvalidDate = true;
          result = false;
        }
      }
    }

    //Q22-Q25: medication ongoing (column E = "No, medication ongoing at time of
    //last encounter") combined with an unknown date of last administration (column C)
    if (repeaterarray.discontinueAgent === 2 && lastDateUnk === 1) {
      result = false;
      repeaterarray.showColC_OngoingUnkError = true;
    } else {
      repeaterarray.showColC_OngoingUnkError = false;
    }

    //Q22 d
    if (
      (isStringEmpty(repeaterarray.noOfAdmission) &&
        isStringEmpty(repeaterarray.noOfAdmissionRadio) &&
        isStringEmpty(repeaterarray.noOfAdmissionUnk) &&
        isStringEmpty(repeaterarray.noOfAdmissionUnkTxt)) ||
      parseInt(repeaterarray.noOfAdmission) < 1 ||
      parseInt(repeaterarray.noOfAdmission) > 4000 ||
      (repeaterarray.noOfAdmissionRadio === 1 &&
        isStringEmpty(repeaterarray.noOfAdmission))
    ) {
      result = false;
      repeaterarray.showColDError = true;
    } else {
      repeaterarray.showColDError = false;

      if (
        repeaterarray.noOfAdmissionUnk === 1 &&
        isStringEmpty(repeaterarray.noOfAdmissionUnkTxt)
      ) {
        result = false;
        repeaterarray.showColDUkTxtError = true;
      } else repeaterarray.showColDUkTxtError = false;
    }

    if (repeaterarray.phaseid === 1 || repeaterarray.phaseid === 4) {
      //Q22G

      if (
        isStringEmpty(repeaterarray.doseAdministrationmg) &&
        isStringEmpty(repeaterarray.doseAdministrationRadiomg) &&
        isStringEmpty(repeaterarray.doseAdministrationkg) &&
        isStringEmpty(repeaterarray.doseAdministrationRadiokg) &&
        isStringEmpty(repeaterarray.doseAdministrationmgm) &&
        isStringEmpty(repeaterarray.doseAdministrationRadiomgm) &&
        isStringEmpty(repeaterarray.doseAdministrationunk)
      ) {
        result = false;
        repeaterarray.showColGError = true;
      } else {
        if (
          (repeaterarray.doseAdministrationRadiomg === 1 &&
            (isStringEmpty(repeaterarray.doseAdministrationmg) ||
              parseFloat(repeaterarray.doseAdministrationmg) < 0.01 ||
              parseFloat(repeaterarray.doseAdministrationmg) >
                getValue(repeaterarray))) ||
          (repeaterarray.doseAdministrationRadiokg === 1 &&
            isStringEmpty(repeaterarray.doseAdministrationkg)) ||
          parseFloat(repeaterarray.doseAdministrationkg) < 0.01 ||
          parseFloat(repeaterarray.doseAdministrationkg) >
            getValue(repeaterarray) ||
          (repeaterarray.doseAdministrationRadiomgm === 1 &&
            isStringEmpty(repeaterarray.doseAdministrationmgm)) ||
          parseFloat(repeaterarray.doseAdministrationmgm) < 0.01 ||
          parseFloat(repeaterarray.doseAdministrationmgm) >
            getValue(repeaterarray)
        ) {
          result = false;
          repeaterarray.showColGError = true;
        } else repeaterarray.showColGError = false;
      }
    }

    //Q22 e
    if (isStringEmpty(repeaterarray.discontinueAgent)) {
      result = false;
      repeaterarray.showColEError = true;
    } else {
      repeaterarray.showColEError = false;
    }

    //Q22 f
    if (repeaterarray.discontinueAgent === 1) {
      const isAnySelected = repeaterarray.reasonForDiscontinuingAgents.some(
        (item) => item.isSelected,
      );
      if (
        isAnySelected ||
        repeaterarray.reasonForDiscontinuingAgents[0].reasonUnk === true ||
        repeaterarray.reasonForDiscontinuingAgents[0].reasonUnk === 1
      ) {
        repeaterarray.showColFError = false;

        const isReasonOtherSelected =
          repeaterarray.reasonForDiscontinuingAgents.some(
            (item) =>
              item.isSelected &&
              item.reasonName.includes("Other") &&
              (item.reasonText === null || item.reasonText.trim() === ""),
          );
        if (isReasonOtherSelected) {
          result = false;
          repeaterarray.showColFOthError = true;
        } else repeaterarray.showColFOthError = false;
      } else {
        result = false;
        repeaterarray.showColFError = true;
      }

      //Q22-Q25: "Patient death" reason requires a known date of death (Q20)
      const isDeathReasonSelected =
        repeaterarray.reasonForDiscontinuingAgents.some(
          (item) =>
            item.isSelected &&
            item.reasonName === DiscontinuingReasons.ReasonPtDeath,
        );
      if (
        isDeathReasonSelected &&
        isStringEmpty(ndmmTreatmentCohortDetails.deathDate)
      ) {
        result = false;
        repeaterarray.showColFDeathError = true;
      } else {
        repeaterarray.showColFDeathError = false;
      }
    }

    //if Q22 to Q25
    const startDt =
      repeaterarray.firstDate === null ||
      repeaterarray.firstDate === "" ||
      repeaterarray.firstDate === "Invalid Date" ||
      !DateInRange(repeaterarray.firstDate, dayjs("01-01-1920"), dayjs())
        ? null
        : parseDate(repeaterarray.firstDate);
    const endDt =
      repeaterarray.lastDate === null ||
      repeaterarray.lastDate === "" ||
      repeaterarray.lastDate === "Invalid Date" ||
      !DateInRange(repeaterarray.lastDate, dayjs("01-01-1920"), dayjs())
        ? null
        : parseDate(repeaterarray.lastDate);
    const endOfFollowUpDt =
      ndmmTreatmentCohortDetails.endOfFollowUp === null ||
      ndmmTreatmentCohortDetails.endOfFollowUp === ""
        ? null
        : parseDate(ndmmTreatmentCohortDetails.endOfFollowUp);

    if (repeaterarray.phaseid === 1 || repeaterarray.phaseid === 4) {
      // If Q22 and Q25
      // Validate the parsed dates
      if (repeaterarray.lastDateUnk !== 1) {
        // Start, end, and end of follow-up present
        if (startDt != null && endDt != null && endOfFollowUpDt != null) {
          // Check if the start date is valid
          const isStartDateValid = startDt <= endDt;

          // Check if the end date is valid
          const isEndDateValid = endDt <= endOfFollowUpDt; // && isStartDateValid

          // Set error flags
          if (!isStartDateValid) {
            repeaterarray.showColB_SEFDateError = true; // Start date is invalid
            result = false;
          } else {
            repeaterarray.showColB_SEFDateError = false; // Start date is valid
          }

          if (!isStartDateValid || !isEndDateValid) {
            repeaterarray.showColC_SEFDateError = true; // End date is invalid
            result = false;
          } else {
            repeaterarray.showColC_SEFDateError = false; // End date is valid
          }
        }
      }
    } else if (repeaterarray.phaseid === 2 || repeaterarray.phaseid === 3) {
      // if Q23 and Q24
      let maxLastDate = "";

      if (
        repeaterarray.phaseid === 2 ||
        (repeaterarray.phaseid === 3 &&
          ndmmTreatmentCohortDetails.q21_1_CT === false)
      ) {
        let listOfDatesExceptUnk =
          ndmmTreatmentCohortDetails.q22_agentData.filter(
            (item) => item.lastDate !== null && item.lastDate !== "",
          );
        if (listOfDatesExceptUnk.length > 0) {
          const maxLastDate22 = getMaxLastDate(listOfDatesExceptUnk);
          maxLastDate = maxLastDate22;
        }
      } else if (
        repeaterarray.phaseid === 3 &&
        ndmmTreatmentCohortDetails.q21_1_CT === true &&
        ndmmTreatmentCohortDetails.q23_agentData.length > 0
      ) {
        let listOfDatesExceptUnk =
          ndmmTreatmentCohortDetails.q23_agentData.filter(
            (item) => item.lastDate !== null && item.lastDate !== "",
          );
        if (listOfDatesExceptUnk.length > 0) {
          const maxLastDate23 = getMaxLastDate(listOfDatesExceptUnk);
          maxLastDate = maxLastDate23;
        }
      }

      // Validate date ranges with maxLastDate
      if (
        maxLastDate !== "" &&
        startDt != null &&
        endDt != null &&
        endOfFollowUpDt != null
      ) {
        const isStartDateValid = maxLastDate <= startDt && startDt <= endDt;
        const isEndDateValid = endDt <= endOfFollowUpDt;

        // Set error flags
        if (!isStartDateValid) {
          repeaterarray.showColB_SEFDateError = true; // Start date is invalid
          result = false;
        } else {
          repeaterarray.showColB_SEFDateError = false; // Start date is valid
        }

        if (!isStartDateValid || !isEndDateValid) {
          repeaterarray.showColC_SEFDateError = true; // End date is invalid
          result = false;
        } else {
          repeaterarray.showColC_SEFDateError = false; // End date is valid
        }
      } else if (startDt != null && endDt != null && endOfFollowUpDt != null) {
        // Validate without maxLastDate
        const isStartDateValid = startDt <= endDt;
        const isEndDateValid = endDt <= endOfFollowUpDt;

        // Set error flags
        if (!isStartDateValid) {
          repeaterarray.showColB_SEFDateError = true; // Start date is invalid
          result = false;
        } else {
          repeaterarray.showColB_SEFDateError = false; // Start date is valid
        }

        if (!isStartDateValid || !isEndDateValid) {
          repeaterarray.showColC_SEFDateError = true; // End date is invalid
          result = false;
        } else {
          repeaterarray.showColC_SEFDateError = false; // End date is valid
        }
      }

      //New Changes: induction agent start date ≤ induction agent end date ≤ consolidation agent start date ≤ consolidation agent end date ≤ maintenance agent start date ≤ maintenance agent end date ≤ end of follow up
      let maxIStartDate = "";
      let maxILastDate = "";
      let maxCStartDate = "";
      let maxCLastDate = "";
      let maxMStartDate = "";
      let maxMLastDate = "";
      if (ndmmTreatmentCohortDetails.q22_agentData.length > 0) {
        let listOfIFirstDatesExceptUnk =
          ndmmTreatmentCohortDetails.q22_agentData.filter(
            (item) =>
              item.firstDate !== null &&
              item.firstDate !== "" &&
              item.firstDate !== "Invalid Date",
          );
        if (listOfIFirstDatesExceptUnk.length > 0) {
          const maxFirstDate22 = getMaxFirstDate(listOfIFirstDatesExceptUnk);
          maxIStartDate = maxFirstDate22;
        }

        let listOfILastDatesExceptUnk =
          ndmmTreatmentCohortDetails.q22_agentData.filter(
            (item) =>
              item.lastDate !== null &&
              item.lastDate !== "" &&
              item.firstDate !== "Invalid Date",
          );

        if (listOfILastDatesExceptUnk.length > 0) {
          const maxLastDate22 = getMaxLastDate(listOfILastDatesExceptUnk);
          maxILastDate = maxLastDate22;
        }
      }
      if (ndmmTreatmentCohortDetails.q23_agentData.length > 0) {
        let listOfCFirstDatesExceptUnk =
          ndmmTreatmentCohortDetails.q23_agentData.filter(
            (item) =>
              item.firstDate !== null &&
              item.firstDate !== "" &&
              item.firstDate !== "Invalid Date",
          );

        if (listOfCFirstDatesExceptUnk.length > 0) {
          const maxFirstDate22 = getMaxFirstDate(listOfCFirstDatesExceptUnk);
          maxCStartDate = maxFirstDate22;
        }

        let listOfCLastDatesExceptUnk =
          ndmmTreatmentCohortDetails.q23_agentData.filter(
            (item) =>
              item.lastDate !== null &&
              item.lastDate !== "" &&
              item.lastDate !== "Invalid Date",
          );

        if (listOfCLastDatesExceptUnk.length > 0) {
          const maxLastDate22 = getMaxLastDate(listOfCLastDatesExceptUnk);
          maxCLastDate = maxLastDate22;
        }
      }
      if (ndmmTreatmentCohortDetails.q24_agentData.length > 0) {
        let listOfMFirstDatesExceptUnk =
          ndmmTreatmentCohortDetails.q24_agentData.filter(
            (item) =>
              item.firstDate !== null &&
              item.firstDate !== "" &&
              item.firstDate !== "Invalid Date",
          );

        if (listOfMFirstDatesExceptUnk.length > 0) {
          const maxFirstDate22 = getMaxFirstDate(listOfMFirstDatesExceptUnk);
          maxMStartDate = maxFirstDate22;
        }

        let listOfMLastDatesExceptUnk =
          ndmmTreatmentCohortDetails.q24_agentData.filter(
            (item) =>
              item.lastDate !== null &&
              item.lastDate !== "" &&
              item.lastDate !== "Invalid Date",
          );

        if (listOfMLastDatesExceptUnk.length > 0) {
          const maxLastDate22 = getMaxLastDate(listOfMLastDatesExceptUnk);
          maxMLastDate = maxLastDate22;
        }
      }

      // consolidation validation
      if (repeaterarray.phaseid === 2) {
        //if (startDt && endDt) {
        const isMaxIStartDateValid =
          maxIStartDate !== "" && maxIStartDate !== null;
        const ismaxILastDateValid =
          maxILastDate !== "" && maxILastDate !== null;

        if (startDt) {
          const isStartDateValid =
            (!isMaxIStartDateValid || maxIStartDate <= startDt) &&
            (!ismaxILastDateValid || maxILastDate <= startDt) &&
            (!startDt || !endDt || startDt <= endDt);

          if (isStartDateValid) {
            repeaterarray.showColB_SEFDateError = false; // Start date is valid
          } else {
            result = false;
            repeaterarray.showColB_SEFDateError = true; // Start date is invalid
          }
        }

        if (endDt) {
          const isEndDateValid =
            endDt <= endOfFollowUpDt &&
            (!isMaxIStartDateValid || maxIStartDate <= endOfFollowUpDt) &&
            (!ismaxILastDateValid || maxILastDate <= endOfFollowUpDt);

          if (isEndDateValid) {
            repeaterarray.showColC_SEFDateError = false; // End date is valid
          } else {
            result = false;
            repeaterarray.showColC_SEFDateError = true; // End date is invalid
          }
        }
        // }
      }

      // maintenance validation
      if (repeaterarray.phaseid === 3) {
        // S6 - NDMM index date
        const ndmmIndexDt = isStringEmpty(
          ndmmTreatmentCohortDetails.ndmmIndexDate,
        )
          ? null
          : parseDate(ndmmTreatmentCohortDetails.ndmmIndexDate);
        const isNdmmIndexDateValid = ndmmIndexDt !== null;

        const isInductionStartDateValid =
          maxIStartDate !== "" && maxIStartDate !== null;
        const isInductionEndDateValid =
          maxILastDate !== "" && maxILastDate !== null;
        const isConsolidationStartDateValid =
          maxCStartDate !== "" && maxCStartDate !== null;
        const isConsolidationEndDateValid =
          maxCLastDate !== "" && maxCLastDate !== null;
        const isMaintenanceStartDateValid = startDt !== "" && startDt !== null;
        const isMaintenanceEndDateValid = endDt !== "" && endDt !== null;
        const isEndOfFollowUpValid =
          endOfFollowUpDt !== "" && endOfFollowUpDt !== null;

        if (startDt) {
          // Validate start date sequence
          // NDMM index date (S6) ≤ latest 1L induction agent end date (Q22 col C) ≤
          // latest 1L consolidation agent end date (Q23 col C) ≤ 1L maintenance agent start date (Q24 col B)
          const isStartDateValid =
            (!isNdmmIndexDateValid || ndmmIndexDt <= startDt) &&
            (!isNdmmIndexDateValid ||
              !isInductionEndDateValid ||
              ndmmIndexDt <= maxILastDate) &&
            (!isInductionStartDateValid ||
              !isInductionEndDateValid ||
              maxIStartDate <= maxILastDate) &&
            (!isInductionEndDateValid ||
              !isConsolidationStartDateValid ||
              maxILastDate <= maxCStartDate) &&
            (!isConsolidationStartDateValid ||
              !isConsolidationEndDateValid ||
              maxCStartDate <= maxCLastDate) &&
            (!isInductionEndDateValid || maxILastDate <= startDt) &&
            (!isConsolidationEndDateValid || maxCLastDate <= startDt);

          // Set error flags
          if (isStartDateValid) {
            repeaterarray.showColB_SEFDateError = false; // Start date is valid
          } else {
            repeaterarray.showColB_SEFDateError = true; // Start date is invalid
            return false;
          }
        }

        if (endDt) {
          // Validate end date sequence
          const isEndDateValid =
            (!isMaintenanceStartDateValid ||
              !startDt ||
              !endDt ||
              startDt <= endDt) &&
            (!isMaintenanceEndDateValid || endDt <= endOfFollowUpDt) &&
            (!isEndOfFollowUpValid ||
              (isMaintenanceEndDateValid && endDt <= endOfFollowUpDt));

          if (isEndDateValid) {
            repeaterarray.showColC_SEFDateError = false; // End date is valid
          } else {
            repeaterarray.showColC_SEFDateError = true; // End date is invalid
            return false;
          }
        }
      }
    }

    if (rrmmAvailable && !isStringEmpty(earliestRRMMDate)) {
      const earliestRRMMDateObj = new Date(earliestRRMMDate);

      if (startDt && earliestRRMMDateObj) {
        const hasStartError = startDt > earliestRRMMDateObj;
        repeaterarray.showColB_RRMMDateError = hasStartError;

        if (hasStartError) {
          result = false;
        }
      }

      if (endDt && earliestRRMMDateObj) {
        const hasEndError = endDt > earliestRRMMDateObj;
        repeaterarray.showColC_RRMMDateError = hasEndError;

        if (hasEndError) {
          result = false;
        }
      }
    }

    //No Start, end and end of follow up present
    //if (repeaterarray.lastDateUnk !== 1) {
    if (startDt === null && endDt != null && endOfFollowUpDt != null) {
      // Check if the last radiotherapy date is within the range
      if (endDt <= endOfFollowUpDt) {
        repeaterarray.showColC_EFDateError = false; //valid
      } else {
        result = false;
        repeaterarray.showColC_EFDateError =
          repeaterarray.lastDate === "" || repeaterarray.lastDate === null
            ? false
            : true; //in-valid
      }
    }
    //}

    //No End, start and end of follow up present
    //if (repeaterarray.firstDateUnk !== 1) {
    if (startDt != null && endDt === null && endOfFollowUpDt != null) {
      // Check if the last radiotherapy date is within the range
      if (startDt <= endOfFollowUpDt) {
        repeaterarray.showColB_SFDateError = false; //valid
      } else {
        result = false;
        repeaterarray.showColB_SFDateError =
          repeaterarray.firstDate === "" || repeaterarray.firstDate === null
            ? false
            : true; //in-valid
      }
    }
    //}

    //No End of follow up, start and end present
    //if (repeaterarray.firstDateUnk !== 1) {
    if (startDt != null && endDt !== null && endOfFollowUpDt === null) {
      // Check if the last radiotherapy date is within the range
      if (startDt <= endDt) {
        repeaterarray.showColB_SEDateError = false; //valid
      } else {
        result = false;
        repeaterarray.showColB_SEDateError =
          repeaterarray.firstDate === "" || repeaterarray.firstDate === null
            ? false
            : true; //in-valid
      }
    }
    //}

    return result;
  }

  function parseDate(dateString) {
    const [month, day, year] = dateString.split("/");
    return new Date(year, month - 1, day);
  }

  function checkValidation(validate) {
    let isValidPromise;
    if (validate) {
      isValidPromise = ValidateForm();
    } else {
      isValidPromise = Promise.resolve(true);
    }

    return isValidPromise;
  }

  const SavePage = async (validate) => {
    try {
      ToggleLoader(true);
      setHardErrList(InitialHardErrList);
      let isValid = validate ? await checkValidation(validate) : true;
      if (isValid) {
        setShowTopErrMsg(false);
        let agentListCombined = [];
        if (
          ndmmTreatmentCohortDetails.show_q25 ||
          ndmmTreatmentCohortDetails.show_q25_tie
        )
          agentListCombined = ndmmTreatmentCohortDetails.q25_agentData;
        else
          agentListCombined = [
            ...ndmmTreatmentCohortDetails.q22_agentData,
            ...ndmmTreatmentCohortDetails.q23_agentData,
            ...ndmmTreatmentCohortDetails.q24_agentData,
          ];
        let lenalidomideDosageLists = [];
        if (
          IsLenalidomideSelectedInQ22State &&
          ndmmTreatmentCohortDetails.q221_lenalidomideData &&
          ndmmTreatmentCohortDetails.q221_lenalidomideData.length > 0
        ) {
          lenalidomideDosageLists =
            ndmmTreatmentCohortDetails.q221_lenalidomideData.map((d) => ({
              Ndmmlenalidomidedosagebridgeid: d.dosageBridgeId || 0,
              Patientid: pid,
              Ndmmphasesid: 1, // Induction phase
              Ndmmtreatmentagentid:
                ndmmTreatmentCohortDetails.q22_agentData?.find(
                  (a) => a.agentName === "Lenalidomide",
                )?.agentid,
              Cohorttreatmentid: ndmmTreatmentCohortDetails.cohortNdmmId,

              // Column A
              Dosestrengthreceived: d.doseStrengthReceivedRadio,
              DosestrengthreceivedDate:
                d.doseStrengthReceivedDate !== "Invalid Date"
                  ? d.doseStrengthReceivedDate
                  : "",

              // Column B
              Dosestrengthreceivedbefore: d.doseStrengthBeforeRadio,
              Dosestrengthbeforeunit: d.doseStrengthBeforeUnit,

              // Column C
              Dosestrengthreceivedafter: d.doseStrengthAfterRadio,
              Dosestrengthafterunit: d.doseStrengthAfterUnit,
            }));
        }

        // Q24.1.A Lenalidomide dosage (Maintenance - Phase 3) - NEW
        if (
          IsLenalidomideSelectedInQ24State &&
          ndmmTreatmentCohortDetails.q241_lenalidomideData &&
          ndmmTreatmentCohortDetails.q241_lenalidomideData.length > 0
        ) {
          const q24Lists = ndmmTreatmentCohortDetails.q241_lenalidomideData.map(
            (d) => ({
              Ndmmlenalidomidedosagebridgeid: d.dosageBridgeId || 0,
              Patientid: pid,
              Ndmmphasesid: 3, // Maintenance phase
              Ndmmtreatmentagentid:
                ndmmTreatmentCohortDetails.q24_agentData?.find(
                  (a) => a.agentName === "Lenalidomide (Revlimid)",
                )?.agentid,
              Cohorttreatmentid: ndmmTreatmentCohortDetails.cohortNdmmId,
              Dosestrengthreceived: d.doseStrengthReceivedRadio,
              DosestrengthreceivedDate:
                d.doseStrengthReceivedDate !== "Invalid Date"
                  ? d.doseStrengthReceivedDate
                  : "",
              Dosestrengthreceivedbefore: d.doseStrengthBeforeRadio,
              Dosestrengthbeforeunit: d.doseStrengthBeforeUnit,
              Dosestrengthreceivedafter: d.doseStrengthAfterRadio,
              Dosestrengthafterunit: d.doseStrengthAfterUnit,
            }),
          );

          lenalidomideDosageLists = [...lenalidomideDosageLists, ...q24Lists];
        }

        if (
          IsLenalidomideSelectedInQ23State &&
          ndmmTreatmentCohortDetails.q231_lenalidomideData &&
          ndmmTreatmentCohortDetails.q231_lenalidomideData.length > 0
        ) {
          const q23Lists = ndmmTreatmentCohortDetails.q231_lenalidomideData.map(
            (d) => ({
              Ndmmlenalidomidedosagebridgeid: d.dosageBridgeId || 0,
              Patientid: pid,
              Ndmmphasesid: 2, // Consolidation phase
              Ndmmtreatmentagentid:
                ndmmTreatmentCohortDetails.q23_agentData?.find(
                  (a) => a.agentName === "Lenalidomide",
                )?.agentid,
              Cohorttreatmentid: ndmmTreatmentCohortDetails.cohortNdmmId,
              Dosestrengthreceived: d.doseStrengthReceivedRadio,
              DosestrengthreceivedDate:
                d.doseStrengthReceivedDate !== "Invalid Date"
                  ? d.doseStrengthReceivedDate
                  : "",
              Dosestrengthreceivedbefore: d.doseStrengthBeforeRadio,
              Dosestrengthbeforeunit: d.doseStrengthBeforeUnit,
              Dosestrengthreceivedafter: d.doseStrengthAfterRadio,
              Dosestrengthafterunit: d.doseStrengthAfterUnit,
            }),
          );
          lenalidomideDosageLists = [...lenalidomideDosageLists, ...q23Lists];
        }

        if (
          IsLenalidomideSelectedInQ25State &&
          ndmmTreatmentCohortDetails.q251_lenalidomideData &&
          ndmmTreatmentCohortDetails.q251_lenalidomideData.length > 0
        ) {
          const q25Lists = ndmmTreatmentCohortDetails.q251_lenalidomideData.map(
            (d) => ({
              Ndmmlenalidomidedosagebridgeid: d.dosageBridgeId || 0,
              Patientid: pid,
              Ndmmphasesid: 4, // TIE phase
              Ndmmtreatmentagentid:
                ndmmTreatmentCohortDetails.q25_agentData?.find(
                  (a) => a.agentName === "Lenalidomide",
                )?.agentid,
              Cohorttreatmentid: ndmmTreatmentCohortDetails.cohortNdmmId,
              Dosestrengthreceived: d.doseStrengthReceivedRadio,
              DosestrengthreceivedDate:
                d.doseStrengthReceivedDate !== "Invalid Date"
                  ? d.doseStrengthReceivedDate
                  : "",
              Dosestrengthreceivedbefore: d.doseStrengthBeforeRadio,
              Dosestrengthbeforeunit: d.doseStrengthBeforeUnit,
              Dosestrengthreceivedafter: d.doseStrengthAfterRadio,
              Dosestrengthafterunit: d.doseStrengthAfterUnit,
            }),
          );
          lenalidomideDosageLists = [...lenalidomideDosageLists, ...q25Lists];
        }

        //Q22.2A and Q24.2A
        const listQ222ABortezomib = BuildBortezomibDoseFrequencyList({
          isSelected: isBortezomibSelectedInQ22,
          isNewEcrfA,
          sourceList:
            ndmmTreatmentCohortDetails.q22ABortezomibDoseFrequencyList,
          ndmmTreatmentCohortDetails,
          pid,
          phaseId: NDMMPhasesId.InductionTherapy,
        });

        const listQ242ABortezomib = BuildBortezomibDoseFrequencyList({
          isSelected: isBortezomibSelectedInQ24,
          isNewEcrfA,
          sourceList:
            ndmmTreatmentCohortDetails.q242ABortezomibDoseFrequencyList,
          ndmmTreatmentCohortDetails,
          pid,
          phaseId: NDMMPhasesId.MaintenanceTherapy,
        });

        const listQ232ABortezomib = BuildBortezomibDoseFrequencyList({
          isSelected: isBortezomibSelectedInQ23,
          isNewEcrfA,
          sourceList:
            ndmmTreatmentCohortDetails.q232ABortezomibDoseFrequencyList,
          ndmmTreatmentCohortDetails,
          pid,
          phaseId: NDMMPhasesId.ConsolidationTherapy,
        });

        const listQ252ABortezomib = BuildBortezomibDoseFrequencyList({
          isSelected: isBortezomibSelectedInQ25,
          isNewEcrfA,
          sourceList:
            ndmmTreatmentCohortDetails.q252ABortezomibDoseFrequencyList,
          ndmmTreatmentCohortDetails,
          pid,
          phaseId: NDMMPhasesId.OtherTherapy,
        });

        const bortezomibDoseFrequencyList = [
          ...listQ222ABortezomib,
          ...listQ242ABortezomib,
          ...listQ232ABortezomib,
          ...listQ252ABortezomib,
        ];

        let ndmmTreatmentModel = {
          patientid: pid,
          cohorttreatmentid: ndmmTreatmentCohortDetails.cohortNdmmId,
          chartDifferent:
            ndmmTreatmentCohortDetails.q21_data == 1
              ? true
              : ndmmTreatmentCohortDetails.q21_data == 2
                ? false
                : null,
          inductionPhase: true,
          consolidatePhase: ndmmTreatmentCohortDetails.q21_1_CT,
          maintenancePhase: ndmmTreatmentCohortDetails.q21_1_MT,
          agentTreatmentLists: agentListCombined,
          nDMMAgentBridgeToDeleteLists:
            ndmmTreatmentCohortDetails.nDMMAgentBridgeToDeleteLists,
          lenalidomideDosageLists:
            lenalidomideDosageLists.length > 0 ? lenalidomideDosageLists : null,
          loggedInUserId: GetLoggedInUserID(),
          isValidated: validate,
          IsAdmin: IsAdmin(),
          bortezomibDoseFrequencyList: bortezomibDoseFrequencyList,
        };
        if (pid > 0) {
          const response =
            await NDMMTreatmentCohortService.SaveNDMMCohortTreatmentData(
              ndmmTreatmentModel,
            );
          if (response.status !== HTTPResponse.OK) {
            ToggleLoader(false);
            if (response?.status === HTTPResponse.Unauthorized) {
              HandleSessionTimeout();
            } else throw response.error;
          } else {
            await GetNDMMCohortTreatmentData();
            ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
          }

          if (response?.data?.showDateChangeAffectAlert) {
            ShowAlertBox();
          }
        }
        return true;
      } else {
        ToggleLoader(false);
        setShowTopErrMsg(true);
        return false;
      }
    } catch (error) {
      ToggleLoader(false);
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  function BuildBortezomibDoseFrequencyList({
    isSelected,
    isNewEcrfA,
    sourceList,
    ndmmTreatmentCohortDetails,
    pid,
    phaseId,
  }) {
    if (!isSelected || !isNewEcrfA) {
      return [];
    }

    if (!Array.isArray(sourceList) || !sourceList.length) {
      return [];
    }
    const agentId =
      phaseId === NDMMPhasesId.InductionTherapy
        ? ndmmTreatmentCohortDetails?.q22_agentData?.find(
            (a) => a.agentName === NDMMCohortAgent.Bortezomib,
          )?.agentid
        : ndmmTreatmentCohortDetails?.q24_agentData?.find(
            (a) => a.agentName === NDMMCohortAgent.Bortezomib,
          )?.agentid;

    return sourceList.map((d) => ({
      Ndmmbortezomibdosagebridgeid: d.ndmmBortezomibDosageBridgeId || 0,

      Patientid: pid,
      Ndmmphasesid: phaseId,
      Ndmmtreatmentagentid: agentId,
      Cohorttreatmentid: ndmmTreatmentCohortDetails?.cohortNdmmId,

      // Column A
      Dosefrequencyreceived: d.doseFrequencyReceived,
      DosefrequencyreceivedDate:
        d.doseFrequencyReceivedDate !== "Invalid Date"
          ? d.doseFrequencyReceivedDate
          : "",

      // Column B
      Dosefrequencyreceivedbefore: d.doseFrequencyReceivedBefore,
      Dosefrequencybeforeunit: d.doseFrequencyBeforeUnit,
      DosefrequencybeforeOthTxt: d.doseFrequencyBeforeOthTxt,

      // Column C
      Dosefrequencyreceivedafter: d.doseFrequencyReceivedAfter,
      Dosefrequencyafterunit: d.doseFrequencyAfterUnit,
      DosefrequencyafterOthTxt: d.doseFrequencyAfterOthTxt,
    }));
  }

  /* <summary>
        date: 27-08-2024
        Name: BV
        description: Show an alert message when other page(end of follow up) could be affected
        <summary>*/
  const ShowAlertBox = async () => {
    const choice = await ShowActionPopUp(
      "Alert", //title
      CommonError_Msgs.DateChangeAlert, //message
      "Ok", //Confirm button text
      true,
    );
  };

  const InitialHardErrList = {
    q21Empty: false,
    q23Empty: false,
    q24Empty: false,
    q23OngoingBlock: false,
    q24OngoingBlock: false,
  };
  const [hardErrList, setHardErrList] = useState(InitialHardErrList);

  const ClearQ21DependentData = (ndmmDetails, q21Value) => {
    const updated = { ...ndmmDetails };

    // Update phase selection states
    const isBortezomibSelectedInQ22 = updated.q22_agentData?.some(
      (a) => a.agentName === NDMMCohortAgent.Bortezomib,
    );
    setIsBortezomibSelectedInQ22(isBortezomibSelectedInQ22);

    const isBortezomibSelectedInQ23 = updated.q23_agentData?.some(
      (a) => a.agentName === NDMMCohortAgentWithSuperScript.Bortezomib,
    );
    setIsBortezomibSelectedInQ23(isBortezomibSelectedInQ23);

    const isBortezomibSelectedInQ24 = updated.q24_agentData?.some(
      (a) => a.agentName === NDMMCohortAgentWithSuperScript.Bortezomib,
    );
    setIsBortezomibSelectedInQ24(isBortezomibSelectedInQ24);

    const isBortezomibSelectedInQ25 = updated.q25_agentData?.some(
      (agent) =>
        agent.agentName === NDMMCohortAgent.Bortezomib &&
        agent.phaseid === NDMMPhasesId.OtherTherapy,
    );
    setIsBortezomibSelectedInQ25(isBortezomibSelectedInQ25);

    //Lenaldomide states
    const isLenalidomideSelectedInQ22 = updated.q22_agentData?.some(
      (a) => a.agentName === NDMMCohortAgent.Lenalidomide,
    );
    setIsLenalidomideSelectedInQ22State(isLenalidomideSelectedInQ22);

    const isLenalidomideSelectedInQ23 = updated.q23_agentData?.some(
      (a) => a.agentName === NDMMCohortAgentWithSuperScript.Lenalidomide,
    );
    setIsLenalidomideSelectedInQ23State(isLenalidomideSelectedInQ23);

    const isLenalidomideSelectedInQ24 = updated.q24_agentData?.some(
      (a) => a.agentName === NDMMCohortAgentWithSuperScript.Lenalidomide,
    );
    setIsLenalidomideSelectedInQ24State(isLenalidomideSelectedInQ24);

    const isLenalidomideSelectedInQ25 = updated.q25_agentData?.some(
      (agent) =>
        agent.agentName === NDMMCohortAgent.Lenalidomide && agent.phaseid === 4,
    );
    setIsLenalidomideSelectedInQ25State(isLenalidomideSelectedInQ25);

    if (q21Value === 1) {
      // YES → Active phases
      updated.q221_lenalidomideData = isLenalidomideSelectedInQ22
        ? [dosageModificationRow]
        : [];
      updated.q231_lenalidomideData = isLenalidomideSelectedInQ23
        ? [dosageModificationRow]
        : [];
      updated.q241_lenalidomideData = isLenalidomideSelectedInQ24
        ? [dosageModificationRow]
        : [];

      updated.q22ABortezomibDoseFrequencyList = isBortezomibSelectedInQ22
        ? [
            {
              ...bortezomibDoseFrequencyRow,
              ndmmPhaseId: NDMMPhasesId.InductionTherapy,
            },
          ]
        : [];
      updated.q232ABortezomibDoseFrequencyList = isBortezomibSelectedInQ23
        ? [
            {
              ...bortezomibDoseFrequencyRow,
              ndmmPhaseId: NDMMPhasesId.ConsolidationTherapy,
            },
          ]
        : [];
      updated.q242ABortezomibDoseFrequencyList = isBortezomibSelectedInQ24
        ? [
            {
              ...bortezomibDoseFrequencyRow,
              ndmmPhaseId: NDMMPhasesId.MaintenanceTherapy,
            },
          ]
        : [];

      // Clear inactive phase
      updated.q251_lenalidomideData = [];
      updated.q252ABortezomibDoseFrequencyList = [];
    } else if (q21Value === 2) {
      // NO → Only OtherTherapy phase active
      updated.q251_lenalidomideData = isLenalidomideSelectedInQ25
        ? [dosageModificationRow]
        : [];
      updated.q252ABortezomibDoseFrequencyList = isBortezomibSelectedInQ25
        ? [
            {
              ...bortezomibDoseFrequencyRow,
              ndmmPhaseId: NDMMPhasesId.OtherTherapy,
            },
          ]
        : [];

      updated.q221_lenalidomideData = [];
      updated.q231_lenalidomideData = [];
      updated.q241_lenalidomideData = [];
      updated.q22ABortezomibDoseFrequencyList = [];
      updated.q232ABortezomibDoseFrequencyList = [];
      updated.q242ABortezomibDoseFrequencyList = [];
    }

    return updated;
  };

  //DN 23/7/24
  const HandleFieldChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "q21_data": {
        //Q21
        const q21_Value = Number(value);

        setHardErrList((prev) => ({
          ...prev,
          q21Empty: false,
          q23Empty: false,
          q24Empty: false,
        }));

        setShowTopErrMsg(false);

        setNDMMTreatmentCohortDetails((prev) => {
          let updated = {
            ...prev,
            [name]: q21_Value,
            show_q21_1: q21_Value === 1,
            show_q25: q21_Value === 2,
            q21_1_CT: false,
            q21_1_MT: false,
          };

          updated.q22_agentData = resetAgents(prev.q22_agentData);
          updated.q23_agentData = resetAgents(prev.q23_agentData);
          updated.q24_agentData = resetAgents(prev.q24_agentData);
          updated.q25_agentData = resetAgents(prev.q25_agentData);

          updated = ClearQ21DependentData(updated, q21_Value);

          return updated;
        });

        break;
      }
      case "q21_1_CT": {
        setNDMMTreatmentCohortDetails((prev) => {
          const newQ21_1_CT = !prev.q21_1_CT;

          const isBortezomibSelectedInQ23 = prev.q23_agentData?.some(
            (a) => a.agentName === NDMMCohortAgentWithSuperScript.Bortezomib,
          );
          setIsBortezomibSelectedInQ23(isBortezomibSelectedInQ23);

          const isLenalidomideSelectedInQ23 = prev.q23_agentData?.some(
            (a) => a.agentName === NDMMCohortAgentWithSuperScript.Lenalidomide,
          );
          setIsLenalidomideSelectedInQ23State(isLenalidomideSelectedInQ23);

          const updatedQ23AgentData = newQ21_1_CT ? prev.q23_agentData : [];
          const updatedQ231LenalidomideData =
            newQ21_1_CT && isLenalidomideSelectedInQ23
              ? [dosageModificationRow]
              : prev.q231_lenalidomideData;

          const updatedQ232BortezomibList =
            newQ21_1_CT && isBortezomibSelectedInQ23
              ? [
                  {
                    ...bortezomibDoseFrequencyRow,
                    ndmmPhaseId: NDMMPhasesId.ConsolidationTherapy,
                  },
                ]
              : [];

          return {
            ...prev,
            [name]: newQ21_1_CT,
            q23_agentData: updatedQ23AgentData,
            q231_lenalidomideData: updatedQ231LenalidomideData,
            q232ABortezomibDoseFrequencyList: updatedQ232BortezomibList,
          };
        });

        setHardErrList((prev) => ({
          ...prev,
          q23Empty: false,
        }));

        break;
      }

      case "q21_1_MT": {
        setNDMMTreatmentCohortDetails((prev) => {
          const newQ21_1_MT = !prev.q21_1_MT;

          const isLenalidomideSelectedInQ24 = prev.q24_agentData?.some(
            (a) => a.agentName === NDMMCohortAgentWithSuperScript.Lenalidomide,
          );
          setIsLenalidomideSelectedInQ24State(isLenalidomideSelectedInQ24);

          const isBortezomibSelectedInQ24 = prev.q24_agentData?.some(
            (a) => a.agentName === NDMMCohortAgentWithSuperScript.Bortezomib,
          );
          setIsBortezomibSelectedInQ24(isBortezomibSelectedInQ24);

          const updatedQ24AgentData = newQ21_1_MT ? prev.q24_agentData : [];
          const updatedQ241LenalidomideData =
            newQ21_1_MT && isLenalidomideSelectedInQ24
              ? [dosageModificationRow]
              : [];

          const updatedQ232BortezomibList =
            newQ21_1_MT && isBortezomibSelectedInQ24
              ? [
                  {
                    ...bortezomibDoseFrequencyRow,
                    ndmmPhaseId: NDMMPhasesId.MaintenanceTherapy,
                  },
                ]
              : [];

          return {
            ...prev,
            [name]: newQ21_1_MT,
            q24_agentData: updatedQ24AgentData,
            q241_lenalidomideData: updatedQ241LenalidomideData,
            q242ABortezomibDoseFrequencyList: updatedQ232BortezomibList,
          };
        });

        setHardErrList((prev) => ({
          ...prev,
          q24Empty: false,
        }));

        break;
      }

      default:
        break;
    }
  };

  const resetAgents = (list = []) =>
    list
      .filter((f) => f.defaultAgent)
      .map((item) => ({
        ...item,

        showColAError: false,
        showColAOthError: false,
        showColAOthDupError: false,
        showColBError: false,
        showColBInvalidDate: false,
        showColB_IdxDateError: false,
        showColB_SFDateError: false,
        showColB_SEDateError: false,
        showColCError: false,
        showColC_SEFDateError: false,
        showColB_SEFDateError: false,
        showColC_EFDateError: false,
        showColC_OngoingUnkError: false,
        showColDError: false,
        showColEError: false,
        showColB_RRMMDateError: false,
        showColC_RRMMDateError: false,

        showColF: false,
        showColFError: false,
        showColFOthError: false,
        showColFDeathError: false,

        agentName: item.defaultAgent ? item.agentName : null,
        agentid: item.defaultAgent ? item.agentid : null,

        discontinueAgent: null,

        firstDate: null,
        firstDateRadio: null,
        firstDateUnk: null,

        lastDate: null,
        lastDateRadio: null,
        lastDateUnk: null,

        noOfAdmission: null,
        noOfAdmissionRadio: null,
        noOfAdmissionUnk: null,
        noOfAdmissionUnkTxt: null,

        doseAdministrationRadiomg: null,
        doseAdministrationmg: null,
        doseAdministrationRadiokg: null,
        doseAdministrationkg: null,
        doseAdministrationRadiomgm: null,
        doseAdministrationmgm: null,
        doseAdministrationunk: null,

        reasonForDiscontinuingAgents: predefinedReasons.map((reason) => ({
          ...reason,
          isSelected: null,
          reasonUnk: null,
        })),
      }));

  const sidebar = document.getElementById("mySidebar");
  const main = document.getElementById("main");

  const toggleNav = () => {
    if (isSideMenuActive === true) {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
      setIsSideMenuActive(false);
    } else if (isSideMenuActive === false) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
      setIsSideMenuActive(true);
    }
  };

  useEffect(() => {
    const sidebar = document.getElementById("mySidebar");
    const main = document.getElementById("main");

    if (isSideMenuActive === true) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
    } else {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
    }
  });

  // ==========================================
  // COMMON HANDLERS FOR Q22.1.A & Q24.1.A
  // ==========================================

  const HandleLenalidomideDosageFieldChange = (
    phaseId,
    e,
    rowIndex,
    fieldName,
  ) => {
    const value = e.target.value;
    const valueInt = Number(value);

    // Determine which state property to update
    let stateKey;

    if (phaseId === NDMMPhasesId.InductionTherapy)
      stateKey = "q221_lenalidomideData";
    else if (phaseId === NDMMPhasesId.ConsolidationTherapy)
      stateKey = "q231_lenalidomideData";
    else if (phaseId === NDMMPhasesId.MaintenanceTherapy)
      stateKey = "q241_lenalidomideData";
    else if (phaseId === NDMMPhasesId.OtherTherapy)
      stateKey = "q251_lenalidomideData";

    setNDMMTreatmentCohortDetails((prev) => {
      const newList = [...prev[stateKey]];
      let updatedRow = { ...newList[rowIndex] };

      if (fieldName === "doseStrengthReceivedRadio") {
        const clearValue = valueInt === 1;

        const clearedDoseFields = clearValue
          ? {
              doseStrengthBeforeRadio: null,
              doseStrengthBeforeUnit: null,
              doseStrengthAfterRadio: null,
              doseStrengthAfterUnit: null,

              showColBError: false,
              showColBValueError: false,
              showColBRangeError: false,
              showColBSameValueError: false,

              showColCError: false,
              showColCValueError: false,
              showColCRangeError: false,
              showColCSameValueError: false,
            }
          : {};

        updatedRow = {
          ...updatedRow,
          doseStrengthReceivedRadio: valueInt,
          doseStrengthReceivedDate:
            valueInt !== 2 ? null : updatedRow.doseStrengthReceivedDate,
          showColAError: false,
          showColADateEmptyError: false,
          showColAInvalidDate: false,
          showColABeforeFirstDateError: false,
          showColAAfterLastDateError: false,
          ...clearedDoseFields,
        };
      } else if (fieldName === "doseStrengthBeforeRadio") {
        updatedRow = {
          ...updatedRow,
          doseStrengthBeforeRadio: valueInt,
          doseStrengthBeforeUnit: null,
          showColBError: false,
          showColBValueError: false,
          showColBRangeError: false,
          showColBSameValueError: false,
        };
      } else if (fieldName === "doseStrengthBeforeUnit") {
        updatedRow = {
          ...updatedRow,
          doseStrengthBeforeUnit: value,
          showColBError: false,
          showColBValueError: false,
          showColBRangeError: false,
          showColBSameValueError: false,
        };
      } else if (fieldName === "doseStrengthAfterRadio") {
        updatedRow = {
          ...updatedRow,
          doseStrengthAfterRadio: valueInt,
          doseStrengthAfterUnit: null,
          showColCError: false,
          showColCValueError: false,
          showColCRangeError: false,
          showColCSameValueError: false,
        };
      } else if (fieldName === "doseStrengthAfterUnit") {
        updatedRow = {
          ...updatedRow,
          doseStrengthAfterUnit: value,
          showColCError: false,
          showColCValueError: false,
          showColCRangeError: false,
          showColCSameValueError: false,
        };
      }

      newList[rowIndex] = updatedRow;

      // remove additional rows
      if (fieldName === "doseStrengthReceivedRadio" && valueInt === 1) {
        return {
          ...prev,
          [stateKey]: newList.slice(0, 1),
        };
      }
      return {
        ...prev,
        [stateKey]: newList,
      };
    });
  };

  const HandleLenalidomideDosageDateChange = (
    phaseId,
    name,
    date,
    rowIndex,
  ) => {
    let stateKey;
    if (phaseId === NDMMPhasesId.InductionTherapy)
      stateKey = "q221_lenalidomideData";
    else if (phaseId === NDMMPhasesId.ConsolidationTherapy)
      stateKey = "q231_lenalidomideData";
    else if (phaseId === NDMMPhasesId.MaintenanceTherapy)
      stateKey = "q241_lenalidomideData";
    else if (phaseId === NDMMPhasesId.OtherTherapy)
      stateKey = "q251_lenalidomideData";

    setNDMMTreatmentCohortDetails((prev) => {
      const newList = [...prev[stateKey]];
      newList[rowIndex] = {
        ...newList[rowIndex],
        doseStrengthReceivedRadio: 2,
        doseStrengthReceivedDate: date,
        showColAError: false,
        showColADateEmptyError: false,
        showColAInvalidDate: false,
        showColABeforeFirstDateError: false,
        showColAAfterLastDateError: false,
      };

      return {
        ...prev,
        [stateKey]: newList,
      };
    });
  };

  const AddLenalidomideDosageRow = (phaseId) => {
    let stateKey;
    if (phaseId === NDMMPhasesId.InductionTherapy)
      stateKey = "q221_lenalidomideData";
    else if (phaseId === NDMMPhasesId.ConsolidationTherapy)
      stateKey = "q231_lenalidomideData";
    else if (phaseId === NDMMPhasesId.MaintenanceTherapy)
      stateKey = "q241_lenalidomideData";
    else if (phaseId === NDMMPhasesId.OtherTherapy)
      stateKey = "q251_lenalidomideData";

    setNDMMTreatmentCohortDetails((prev) => ({
      ...prev,
      [stateKey]: [...prev[stateKey], { ...dosageModificationRow }],
    }));
  };

  const DeleteLenalidomideDosageRow = (phaseId, rowIndex) => {
    let stateKey;
    if (phaseId === NDMMPhasesId.InductionTherapy)
      stateKey = "q221_lenalidomideData";
    else if (phaseId === NDMMPhasesId.ConsolidationTherapy)
      stateKey = "q231_lenalidomideData";
    else if (phaseId === NDMMPhasesId.MaintenanceTherapy)
      stateKey = "q241_lenalidomideData";
    else if (phaseId === NDMMPhasesId.OtherTherapy)
      stateKey = "q251_lenalidomideData";

    setNDMMTreatmentCohortDetails((prev) => {
      const newList = [...prev[stateKey]];
      const deletedRow = newList[rowIndex];

      const updatedDeleteList = deletedRow.dosageBridgeId
        ? [
            ...prev.nDMMDosageBridgeToDeleteLists,
            { Ndmmlenalidomidedosagebridgeid: deletedRow.dosageBridgeId },
          ]
        : prev.nDMMDosageBridgeToDeleteLists;

      newList.splice(rowIndex, 1);

      return {
        ...prev,
        [stateKey]: newList,
        nDMMDosageBridgeToDeleteLists: updatedDeleteList,
      };
    });
  };

  const UpdateTreatmentDoseFrequencyList = (listKey, updatedList) => {
    setNDMMTreatmentCohortDetails((prev) => ({
      ...prev,
      [listKey]: updatedList,
    }));
  };

  const CheckDropwdownSelection = (agentData, phaseId) => {
    const isLenalidomideSelected = agentData.some(
      (agent) =>
        agent.agentName === NDMMCohortAgentWithSuperScript.Lenalidomide,
    );

    const isBortezomibSelected = agentData.some(
      (agent) => agent.agentName === NDMMCohortAgentWithSuperScript.Bortezomib,
    );

    const getUpdatedList = (prevList, defaultRow, isSelected) => {
      if (!isSelected) return [defaultRow];

      return prevList && prevList.length > 0 ? prevList : [defaultRow];
    };

    const phaseConfig = {
      [NDMMPhasesId.ConsolidationTherapy]: {
        lenState: setIsLenalidomideSelectedInQ23State,
        agentKey: "q23_agentData",
        lenKey: "q231_lenalidomideData",

        borState: setIsBortezomibSelectedInQ23,
        borKey: "q232ABortezomibDoseFrequencyList",
      },

      [NDMMPhasesId.MaintenanceTherapy]: {
        lenState: setIsLenalidomideSelectedInQ24State,
        agentKey: "q24_agentData",
        lenKey: "q241_lenalidomideData",

        borState: setIsBortezomibSelectedInQ24,
        borKey: "q242ABortezomibDoseFrequencyList",
      },

      [NDMMPhasesId.OtherTherapy]: {
        lenState: setIsLenalidomideSelectedInQ25State,
        agentKey: "q25_agentData",
        lenKey: "q251_lenalidomideData",

        borState: setIsBortezomibSelectedInQ25,
        borKey: "q252ABortezomibDoseFrequencyList",
      },
    };

    const config = phaseConfig[phaseId];

    if (!config) return;

    config.lenState?.(isLenalidomideSelected);
    config.borState?.(isBortezomibSelected);

    // Single state update
    setNDMMTreatmentCohortDetails((prev) => {
      const updated = { ...prev };

      // Agent Data
      if (config.agentKey) {
        updated[config.agentKey] = agentData;
      }

      // Lenalidomide
      if (config.lenKey) {
        updated[config.lenKey] = getUpdatedList(
          prev[config.lenKey],
          dosageModificationRow,
          isLenalidomideSelected,
        );
      }

      // Bortezomib
      if (config.borKey) {
        updated[config.borKey] = getUpdatedList(
          prev[config.borKey],
          bortezomibDoseFrequencyRow,
          isBortezomibSelected,
        );
      }

      return updated;
    });
  };

  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>
      <section className="main-survey-section">
        <div>
          <SideBarMenu activePageId={SideMenuItems.NDMMTreatmentCohort} />
          <>
            <button
              className={isSideMenuActive ? "openbtn" : "openbtn active"}
              // onclick="toggleNav()"
              onClick={() => toggleNav()}
            >
              <i
                id="arrowNavigation"
                className="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>
          <div className="col-pad-left" id="main">
            <div className="survey-section-content">
              <div className="survey-section-content-header">
                <h4>1L NDMM TREATMENT COHORT</h4>
              </div>
              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}
              <div className="survey-question-section">
                <div className="survey-question-content">
                  <div className="question-answer">
                    <div className="cohort-header">
                      <span>{ndmmTreatmentCohortDetails.ndmmDisplayName}</span>
                    </div>
                    {ndmmTreatmentCohortDetails.show_q21_q25 && (
                      <div>
                        {/* Q21 */}
                        <div className="question-bot-sapce">
                          <div className="question question-weight">
                            <span>Q21.</span>
                            <span className="quest-text-pad">
                              Does the patient’s chart differentiate between{" "}
                              <span
                                data-tooltip-id="encounterTip"
                                style={{ color: "blue" }}
                                onClick={() => {
                                  setShowHideHyperlinkModal(true);
                                }}
                              >
                                <u>
                                  induction, consolidation, and maintenance
                                  therapy phases,
                                </u>
                              </span>
                              {showHideHyperlinkModal && (
                                <InfoPopUp
                                  description={hyperlinkTextQ21}
                                  OkClick={() => {
                                    setShowHideHyperlinkModal(false);
                                  }}
                                />
                              )}{" "}
                              or can these phases be inferred by review of the
                              patient’s records (see the suggestive definition
                              in the link above when hovering over), as part of
                              their 1L NDMM treatment with{" "}
                              <span
                                style={{ color: PageDesignConstants.fontColor }}
                              >
                                <b>
                                  {ndmmTreatmentCohortDetails.ndmmDisplayName}
                                </b>
                              </span>{" "}
                              initiated on{" "}
                              <span
                                style={{ color: PageDesignConstants.fontColor }}
                              >
                                <b>
                                  {ndmmTreatmentCohortDetails.ndmmIndexDate}
                                </b>
                              </span>
                              ?
                            </span>
                          </div>
                          <div className=" double-dig-answer">
                            <div className="">
                              <input
                                type="radio"
                                id={`q21_yes`}
                                name={`q21_data`}
                                value={1}
                                checked={
                                  ndmmTreatmentCohortDetails.q21_data === 1
                                }
                                onChange={HandleFieldChange}
                              />
                              <label htmlFor={`q21_yes`}>
                                <span className="radio-text-padding">Yes</span>
                              </label>
                            </div>
                            <div className="">
                              <input
                                type="radio"
                                id={`q21_no`}
                                name={`q21_data`}
                                value={2}
                                checked={
                                  ndmmTreatmentCohortDetails.q21_data === 2
                                }
                                onChange={HandleFieldChange}
                              />
                              <label htmlFor={`q21_no`}>
                                <span className="radio-text-padding">No</span>
                              </label>
                            </div>
                          </div>
                          <ErrorField
                            show={hardErrList.q21Empty}
                            message={NDMMTreatmentCohort_Msgs.q21}
                          />
                        </div>

                        {ndmmTreatmentCohortDetails.show_q21_1 && (
                          <div>
                            {/* Q21.1 */}
                            <div className="question-bot-sapce">
                              <div className="question question-weight">
                                <span>Q21.1.</span>
                                <span className="quest-text-pad">
                                  Which of the following phases were identified
                                  for the patient while on treatment with{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    <b>
                                      {
                                        ndmmTreatmentCohortDetails.ndmmDisplayName
                                      }
                                    </b>
                                  </span>
                                  ?
                                </span>
                              </div>
                              <div className=" double-dig-answer">
                                <div className="">
                                  <input
                                    type="checkbox"
                                    id="q21_1_IT"
                                    name="q21_1_IT"
                                    checked={true}
                                  />
                                  <label htmlFor="q21_1_IT">
                                    <span className="radio-text-padding">
                                      Induction therapy{" "}
                                    </span>
                                  </label>
                                </div>
                                <div className="">
                                  <input
                                    type="checkbox"
                                    id="q21_1_CT"
                                    name="q21_1_CT"
                                    checked={
                                      ndmmTreatmentCohortDetails.q21_1_CT
                                    }
                                    onChange={HandleFieldChange}
                                  />
                                  <label htmlFor="q21_1_CT">
                                    <span className="radio-text-padding">
                                      Consolidation therapy
                                    </span>
                                  </label>
                                </div>
                                <div className="">
                                  <input
                                    type="checkbox"
                                    id="q21_1_MT"
                                    name="q21_1_MT"
                                    // value={ndmmTreatmentCohortDetails.q21_1_MT}
                                    checked={
                                      ndmmTreatmentCohortDetails.q21_1_MT
                                    }
                                    onChange={HandleFieldChange}
                                  />
                                  <label htmlFor="q21_1_MT">
                                    <span className="radio-text-padding">
                                      Maintenance therapy
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>

                            {/* Q22 */}
                            <div className="question-bot-sapce">
                              <div className="question question-weight">
                                <span>Q22.</span>
                                <span className="quest-text-pad">
                                  Describe the prescribed dosing information for
                                  each agent used as{" "}
                                  <i>
                                    <u>induction therapy</u>
                                  </i>{" "}
                                  as part of the patient’s 1L NDMM treatment
                                  with{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    <b>
                                      {
                                        ndmmTreatmentCohortDetails.ndmmDisplayName
                                      }
                                    </b>
                                  </span>{" "}
                                  initiated on{" "}
                                  <span
                                    style={{
                                      color: PageDesignConstants.fontColor,
                                    }}
                                  >
                                    <b>
                                      {ndmmTreatmentCohortDetails.ndmmIndexDate}
                                    </b>
                                  </span>
                                  . <b><u>Please note the following:</u></b>
                                  <br />
                                  <b>
                                    (a) Date of first administration for one
                                    of the agents must match with the start
                                    date of the 1L therapy on{" "}
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                      }}
                                    >
                                      {
                                        ndmmTreatmentCohortDetails.ndmmIndexDate
                                      }
                                    </span>
                                  </b>
                                  <br />
                                  <b>
                                    (b) Date of first administration of each
                                    agent must be no later than the date of
                                    last administration of the same agent.
                                    Date of last administration must be no
                                    later than the date of the first stem
                                    cell transplant (SCT) received on this
                                    line of treatment (if the patient
                                    received transplant)
                                  </b>
                                  <br />
                                  <b>
                                    (c) None of the dates of first
                                    administration or last administration
                                    should be later than the end of follow
                                    up on{" "}
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                      }}
                                    >
                                      {
                                        ndmmTreatmentCohortDetails.endOfFollowUp
                                      }
                                    </span>
                                    . Please note that, for patients
                                    receiving one cycle of CyBorD, the date
                                    of initiation of 1L treatment begins with
                                    the first dose of the DR/DRd, DVR/DVRd,
                                    VR/VRd, or IsaVR/IsaVRd regimen.
                                  </b>
                                  <br />
                                  <b>
                                    (d) If the total number of administrations
                                    is unknown, please provide information on
                                    frequency of administration and number of
                                    days per cycle of treatment (e.g., “Days
                                    1, 8, and 15 of 21-day cycle for 2 cycles
                                    then Days 1 and 15 of 21-day cycle for
                                    subsequent cycles”).
                                  </b>
                                  <br />
                                  <b>
                                    (e) If a medication agent’s
                                    discontinuation status is “No, medication
                                    ongoing at time of last encounter”
                                    below, please enter the “Date of the last
                                    administration” as the last known
                                    administration date on or prior to the
                                    patient’s last encounter date on{" "}
                                    <span
                                      style={{
                                        color: PageDesignConstants.fontColor,
                                      }}
                                    >
                                      {ndmmTreatmentCohortDetails.lastEncounterDate
                                        ? ndmmTreatmentCohortDetails.lastEncounterDate
                                        : "[date of last encounter]"}
                                    </span>
                                    .
                                  </b>
                                </span>
                              </div>
                              <div className=" double-dig-answer">
                                <NDMMAgentData
                                  phaseid={1}
                                  agentList={
                                    ndmmTreatmentCohortDetails.q22_agentList
                                  }
                                  agentData={
                                    ndmmTreatmentCohortDetails.q22_agentData
                                  }
                                  setAgentData={(newData) =>
                                    setNDMMTreatmentCohortDetails(
                                      (prevState) => ({
                                        ...prevState,
                                        q22_agentData: newData,
                                      }),
                                    )
                                  }
                                  listToDelete={
                                    ndmmTreatmentCohortDetails.nDMMAgentBridgeToDeleteLists
                                  }
                                  lastEncounterDate={
                                    ndmmTreatmentCohortDetails.lastEncounterDate
                                  }
                                  hideOngoingOption={
                                    ndmmTreatmentCohortDetails.q21_1_MT
                                  }
                                />
                              </div>
                            </div>

                            {/* Q22.1.A */}
                            {IsLenalidomideSelectedInQ22State && isNewEcrfA && (
                              <NDMMDosageModification
                                questionNumber="Q22.1.A"
                                phaseId={NDMMPhasesId.InductionTherapy}
                                agentName="Lenalidomide"
                                agentBridgeId={
                                  ndmmTreatmentCohortDetails.q22_agentData.find(
                                    (a) => a.agentName === "Lenalidomide",
                                  )?.agentBridgeId
                                }
                                agentFirstDate={
                                  ndmmTreatmentCohortDetails.q22_agentData.find(
                                    (a) => a.agentName === "Lenalidomide",
                                  )?.firstDate
                                }
                                agentLastDate={
                                  ndmmTreatmentCohortDetails.q22_agentData.find(
                                    (a) => a.agentName === "Lenalidomide",
                                  )?.lastDate
                                }
                                endOfFollowUpDate={
                                  ndmmTreatmentCohortDetails.endOfFollowUp
                                }
                                dosageList={
                                  ndmmTreatmentCohortDetails.q221_lenalidomideData
                                }
                                onDosageChange={(e, rowIndex, fieldName) =>
                                  HandleLenalidomideDosageFieldChange(
                                    1,
                                    e,
                                    rowIndex,
                                    fieldName,
                                  )
                                }
                                onDosageDateChange={(name, date, rowIndex) =>
                                  HandleLenalidomideDosageDateChange(
                                    1,
                                    name,
                                    date,
                                    rowIndex,
                                  )
                                }
                                onAddRow={() => AddLenalidomideDosageRow(1)}
                                onDeleteRow={(rowIndex) =>
                                  DeleteLenalidomideDosageRow(1, rowIndex)
                                }
                              />
                            )}

                            {/* Q22.2A */}
                            {isNewEcrfA &&
                              isBortezomibSelectedInQ22 &&
                              ndmmTreatmentCohortDetails
                                .q22ABortezomibDoseFrequencyList?.length >
                                0 && (
                                <DoseFrequencyModificationTable
                                  key="q22ABortezomibDoseFrequencyList_Induction"
                                  title={{
                                    code: "Q22.2A.",
                                    text: (
                                      <>
                                        Please provide information on all{" "}
                                        <i>
                                          <u>
                                            bortezomib dose frequency
                                            modifications
                                          </u>{" "}
                                        </i>
                                        that occurred during
                                        <i>
                                          {" "}
                                          <u>induction therapy</u>
                                        </i>
                                        .
                                      </>
                                    ),
                                  }}
                                  ndmmTreatmentCohortDetails={
                                    ndmmTreatmentCohortDetails
                                  }
                                  treatmentRow={bortezomibDoseFrequencyRow}
                                  treatmentName={NDMMCohortAgent.Bortezomib}
                                  listKey="q22ABortezomibDoseFrequencyList"
                                  ndmmPhasesId={NDMMPhasesId.InductionTherapy}
                                  UpdateTreatmentDoseFrequencyList={
                                    UpdateTreatmentDoseFrequencyList
                                  }
                                />
                              )}

                            {/* Q23 */}
                            {ndmmTreatmentCohortDetails.q21_1_CT && (
                              <>
                                <div className="question-bot-sapce">
                                  <div className="question question-weight">
                                    <span>Q23.</span>
                                    <span className="quest-text-pad">
                                      Describe the prescribed dosing information
                                      for each agent used as{" "}
                                      <i>
                                        <u>consolidation therapy</u>
                                      </i>{" "}
                                      as part of the patient’s 1L NDMM treatment
                                      with{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        <b>
                                          {
                                            ndmmTreatmentCohortDetails.ndmmDisplayName
                                          }
                                        </b>
                                      </span>{" "}
                                      initiated on{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        <b>
                                          {
                                            ndmmTreatmentCohortDetails.ndmmIndexDate
                                          }
                                        </b>
                                      </span>
                                      . <b><u>Please note the following:</u></b>
                                      <br />
                                      <b>
                                        (a) Earliest date of first
                                        administration for agents used
                                        during consolidation therapy must be
                                        on or after the latest date of last
                                        administration for agents used
                                        during induction therapy
                                      </b>
                                      <br />
                                      <b>
                                        (b) Earliest date of first
                                        administration must be on or after
                                        the date of the first stem cell
                                        transplant (SCT) received on this
                                        line of treatment (if the patient
                                        received transplant)
                                      </b>
                                      <br />
                                      <b>
                                        (c) Date of first administration of
                                        each agent must be no later than the
                                        date of last administration of the
                                        same agent
                                      </b>
                                      <br />
                                      <b>
                                        (d) None of the dates of first
                                        administration or last
                                        administration should be later than
                                        the end of follow up{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                          }}
                                        >
                                          {
                                            ndmmTreatmentCohortDetails.endOfFollowUp
                                          }
                                        </span>
                                        .
                                      </b>
                                      <br />
                                      <b>
                                        (e) If the total number of
                                        administrations is unknown, please
                                        provide information on frequency of
                                        administration and number of days
                                        per cycle of treatment (e.g., “Days
                                        1, 8, and 15 of 21-day cycle for 2
                                        cycles then Days 1 and 15 of 21-day
                                        cycle for subsequent cycles”).
                                      </b>
                                      <br />
                                      <b>
                                        (f) If a medication agent’s
                                        discontinuation status is “No,
                                        medication ongoing at time of last
                                        encounter” below, please enter the
                                        “Date of the last administration” as
                                        the last known administration date
                                        on or prior to the patient’s last
                                        encounter date on{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                          }}
                                        >
                                          {ndmmTreatmentCohortDetails.lastEncounterDate
                                            ? ndmmTreatmentCohortDetails.lastEncounterDate
                                            : "[date of last encounter]"}
                                        </span>
                                        .
                                      </b>
                                    </span>
                                  </div>
                                  <ErrorField
                                    show={hardErrList.q23OngoingBlock}
                                    message={
                                      NDMMTreatmentCohort_Msgs.q23_ongoingBlock
                                    }
                                  />
                                  <div className=" double-dig-answer">
                                    <NDMMAgentData
                                      phaseid={2}
                                      agentList={
                                        ndmmTreatmentCohortDetails.q23_agentList
                                      }
                                      agentData={
                                        ndmmTreatmentCohortDetails.q23_agentData
                                      }
                                      // setAgentData={(newData) =>
                                      //   setNDMMTreatmentCohortDetails(
                                      //     (prevState) => ({
                                      //       ...prevState,
                                      //       q23_agentData: newData,
                                      //     }),
                                      //   )

                                      // }
                                      setAgentData={(newData) => {
                                        setNDMMTreatmentCohortDetails(
                                          (prev) => ({
                                            ...prev,
                                            q23_agentData: newData,
                                          }),
                                        );
                                        CheckDropwdownSelection(newData, 2);
                                      }}
                                      listToDelete={
                                        ndmmTreatmentCohortDetails.nDMMAgentBridgeToDeleteLists
                                      }
                                      onAgentSelectionChange={
                                        CheckDropwdownSelection
                                      }
                                      lastEncounterDate={
                                        ndmmTreatmentCohortDetails.lastEncounterDate
                                      }
                                      hideOngoingOption={
                                        ndmmTreatmentCohortDetails.q21_1_MT
                                      }
                                    />
                                    {ndmmTreatmentCohortDetails.q23_agentData
                                      .length === 0 && (
                                      <ErrorField
                                        show={hardErrList.q23Empty}
                                        message={NDMMTreatmentCohort_Msgs.q23}
                                      />
                                    )}
                                  </div>
                                </div>

                                {/* Q23.1.A */}
                                {IsLenalidomideSelectedInQ23State &&
                                  isNewEcrfA && (
                                    <NDMMDosageModification
                                      questionNumber="Q23.1.A"
                                      phaseId={
                                        NDMMPhasesId.ConsolidationTherapy
                                      } // Consolidation
                                      agentName="Lenalidomide"
                                      agentBridgeId={
                                        ndmmTreatmentCohortDetails.q23_agentData?.find(
                                          (a) => a.agentName === "Lenalidomide",
                                        )?.agentBridgeId
                                      }
                                      agentFirstDate={
                                        ndmmTreatmentCohortDetails.q23_agentData?.find(
                                          (a) => a.agentName === "Lenalidomide",
                                        )?.firstDate
                                      }
                                      agentLastDate={
                                        ndmmTreatmentCohortDetails.q23_agentData?.find(
                                          (a) => a.agentName === "Lenalidomide",
                                        )?.lastDate
                                      }
                                      endOfFollowUpDate={
                                        ndmmTreatmentCohortDetails.endOfFollowUp
                                      }
                                      dosageList={
                                        ndmmTreatmentCohortDetails.q231_lenalidomideData
                                      }
                                      onDosageChange={(
                                        e,
                                        rowIndex,
                                        fieldName,
                                      ) =>
                                        HandleLenalidomideDosageFieldChange(
                                          2,
                                          e,
                                          rowIndex,
                                          fieldName,
                                        )
                                      }
                                      onDosageDateChange={(
                                        name,
                                        date,
                                        rowIndex,
                                      ) =>
                                        HandleLenalidomideDosageDateChange(
                                          2,
                                          name,
                                          date,
                                          rowIndex,
                                        )
                                      }
                                      onAddRow={() =>
                                        AddLenalidomideDosageRow(2)
                                      }
                                      onDeleteRow={(rowIndex) =>
                                        DeleteLenalidomideDosageRow(2, rowIndex)
                                      }
                                    />
                                  )}

                                {/* Q23.2A */}
                                {isNewEcrfA &&
                                  isBortezomibSelectedInQ23 &&
                                  ndmmTreatmentCohortDetails
                                    .q232ABortezomibDoseFrequencyList?.length >
                                    0 && (
                                    <DoseFrequencyModificationTable
                                      key="q232ABortezomibDoseFrequencyList_Consolidation"
                                      title={{
                                        code: "Q23.2A.",
                                        text: (
                                          <>
                                            Please provide information on all{" "}
                                            <i>
                                              <u>
                                                bortezomib dose frequency
                                                modifications
                                              </u>{" "}
                                            </i>{" "}
                                            that occurred during
                                            <i>
                                              {" "}
                                              <u>consolidation therapy</u>
                                            </i>
                                            .
                                          </>
                                        ),
                                      }}
                                      ndmmTreatmentCohortDetails={
                                        ndmmTreatmentCohortDetails
                                      }
                                      treatmentRow={bortezomibDoseFrequencyRow}
                                      treatmentName={NDMMCohortAgent.Bortezomib}
                                      listKey="q232ABortezomibDoseFrequencyList"
                                      ndmmPhasesId={
                                        NDMMPhasesId.ConsolidationTherapy
                                      }
                                      UpdateTreatmentDoseFrequencyList={
                                        UpdateTreatmentDoseFrequencyList
                                      }
                                    />
                                  )}
                              </>
                            )}

                            {/* Q24 */}
                            {ndmmTreatmentCohortDetails.q21_1_MT && (
                              <>
                                <div className="question-bot-sapce">
                                  <div className="question question-weight">
                                    <span>Q24.</span>
                                    <span className="quest-text-pad">
                                      Describe the prescribed dosing information
                                      for each agent used as{" "}
                                      <i>
                                        <u>maintenance therapy</u>
                                      </i>{" "}
                                      as part of the patient’s 1L NDMM treatment
                                      with{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        <b>
                                          {
                                            ndmmTreatmentCohortDetails.ndmmDisplayName
                                          }
                                        </b>
                                      </span>{" "}
                                      initiated on{" "}
                                      <span
                                        style={{
                                          color: PageDesignConstants.fontColor,
                                        }}
                                      >
                                        <b>
                                          {
                                            ndmmTreatmentCohortDetails.ndmmIndexDate
                                          }
                                        </b>
                                      </span>
                                      . <b><u>Please note the following:</u></b>
                                      <br />
                                      <b>
                                        (a) Earliest date of first
                                        administration for agents used
                                        during maintenance therapy must be
                                        on or after the latest date of last
                                        administration for agents used
                                        during consolidation therapy and
                                        induction therapy
                                      </b>
                                      <br />
                                      <b>
                                        (b) Earliest date of first
                                        administration must be on or after
                                        the date of the first stem cell
                                        transplant (SCT) received on this
                                        line of treatment (if the patient
                                        received transplant)
                                      </b>
                                      <br />
                                      <b>
                                        (c) Date of first administration of
                                        each agent must be no later than the
                                        date of last administration of the
                                        same agent
                                      </b>
                                      <br />
                                      <b>
                                        (d) None of the dates of first
                                        administration or last
                                        administration should be later than
                                        the end of follow up{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                          }}
                                        >
                                          {
                                            ndmmTreatmentCohortDetails.endOfFollowUp
                                          }
                                        </span>
                                        .
                                      </b>
                                      <br />
                                      <b>
                                        (e) If the total number of
                                        administrations is unknown, please
                                        provide information on frequency of
                                        administration and number of days
                                        per cycle of treatment (e.g., “Days
                                        1, 8, and 15 of 21-day cycle for 2
                                        cycles then Days 1 and 15 of 21-day
                                        cycle for subsequent cycles”).
                                      </b>
                                      <br />
                                      <b>
                                        (f) If a medication agent’s
                                        discontinuation status is “No,
                                        medication ongoing at time of last
                                        encounter” below, please enter the
                                        “Date of the last administration” as
                                        the last known administration date
                                        on or prior to the patient’s last
                                        encounter date on{" "}
                                        <span
                                          style={{
                                            color:
                                              PageDesignConstants.fontColor,
                                          }}
                                        >
                                          {ndmmTreatmentCohortDetails.lastEncounterDate
                                            ? ndmmTreatmentCohortDetails.lastEncounterDate
                                            : "[date of last encounter]"}
                                        </span>
                                        .
                                      </b>
                                    </span>
                                  </div>
                                  <ErrorField
                                    show={hardErrList.q24OngoingBlock}
                                    message={
                                      NDMMTreatmentCohort_Msgs.q24_ongoingBlock
                                    }
                                  />
                                  <div className=" double-dig-answer">
                                    <NDMMAgentData
                                      phaseid={3}
                                      agentList={
                                        ndmmTreatmentCohortDetails.q24_agentList
                                      }
                                      agentData={
                                        ndmmTreatmentCohortDetails.q24_agentData
                                      }
                                      // setAgentData={(newData) =>
                                      //   setNDMMTreatmentCohortDetails(
                                      //     (prevState) => ({
                                      //       ...prevState,
                                      //       q24_agentData: newData,
                                      //     }),
                                      //   )
                                      // }

                                      setAgentData={(newData) => {
                                        setNDMMTreatmentCohortDetails(
                                          (prev) => ({
                                            ...prev,
                                            q24_agentData: newData,
                                          }),
                                        );
                                        CheckDropwdownSelection(newData, 3); // <- handles delete + reset
                                      }}
                                      listToDelete={
                                        ndmmTreatmentCohortDetails.nDMMAgentBridgeToDeleteLists
                                      }
                                      onAgentSelectionChange={
                                        CheckDropwdownSelection
                                      }
                                      lastEncounterDate={
                                        ndmmTreatmentCohortDetails.lastEncounterDate
                                      }
                                      hideOngoingOption={rrmmAvailable}
                                    />
                                    {ndmmTreatmentCohortDetails.q24_agentData
                                      .length === 0 && (
                                      <ErrorField
                                        show={hardErrList.q24Empty}
                                        message={NDMMTreatmentCohort_Msgs.q24}
                                      />
                                    )}
                                  </div>
                                </div>

                                {/* Q24.1.A */}
                                {IsLenalidomideSelectedInQ24State &&
                                  isNewEcrfA && (
                                    <NDMMDosageModification
                                      questionNumber="Q24.1.A"
                                      phaseId={NDMMPhasesId.MaintenanceTherapy}
                                      agentName="Lenalidomide"
                                      agentBridgeId={
                                        ndmmTreatmentCohortDetails.q24_agentData.find(
                                          (a) => a.agentName === "Lenalidomide",
                                        )?.agentBridgeId
                                      }
                                      agentFirstDate={
                                        ndmmTreatmentCohortDetails.q24_agentData.find(
                                          (a) => a.agentName === "Lenalidomide",
                                        )?.firstDate
                                      }
                                      agentLastDate={
                                        ndmmTreatmentCohortDetails.q24_agentData.find(
                                          (a) => a.agentName === "Lenalidomide",
                                        )?.lastDate
                                      }
                                      endOfFollowUpDate={
                                        ndmmTreatmentCohortDetails.endOfFollowUp
                                      }
                                      dosageList={
                                        ndmmTreatmentCohortDetails.q241_lenalidomideData
                                      }
                                      onDosageChange={(
                                        e,
                                        rowIndex,
                                        fieldName,
                                      ) =>
                                        HandleLenalidomideDosageFieldChange(
                                          3,
                                          e,
                                          rowIndex,
                                          fieldName,
                                        )
                                      }
                                      onDosageDateChange={(
                                        name,
                                        date,
                                        rowIndex,
                                      ) =>
                                        HandleLenalidomideDosageDateChange(
                                          3,
                                          name,
                                          date,
                                          rowIndex,
                                        )
                                      }
                                      onAddRow={() =>
                                        AddLenalidomideDosageRow(3)
                                      }
                                      onDeleteRow={(rowIndex) =>
                                        DeleteLenalidomideDosageRow(3, rowIndex)
                                      }
                                    />
                                  )}

                                {/* Q24.2.A */}
                                {isNewEcrfA &&
                                  isBortezomibSelectedInQ24 &&
                                  ndmmTreatmentCohortDetails
                                    .q242ABortezomibDoseFrequencyList?.length >
                                    0 && (
                                    <DoseFrequencyModificationTable
                                      key="q242ABortezomibDoseFrequencyList_Maintenance"
                                      title={{
                                        code: "Q24.2A.",
                                        text: (
                                          <>
                                            Please provide information on all{" "}
                                            <i>
                                              <u>
                                                bortezomib dose frequency
                                                modifications
                                              </u>{" "}
                                            </i>{" "}
                                            that occurred during{" "}
                                            <i>
                                              <u>maintenance therapy</u>
                                            </i>
                                            .
                                          </>
                                        ),
                                      }}
                                      ndmmTreatmentCohortDetails={
                                        ndmmTreatmentCohortDetails
                                      }
                                      treatmentRow={bortezomibDoseFrequencyRow}
                                      treatmentName={NDMMCohortAgent.Bortezomib}
                                      listKey="q242ABortezomibDoseFrequencyList"
                                      ndmmPhasesId={
                                        NDMMPhasesId.MaintenanceTherapy
                                      }
                                      UpdateTreatmentDoseFrequencyList={
                                        UpdateTreatmentDoseFrequencyList
                                      }
                                    />
                                  )}
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    )}

                    {/* Q25 */}
                    {(ndmmTreatmentCohortDetails.show_q25 ||
                      ndmmTreatmentCohortDetails.show_q25_tie) && (
                      <>
                        <div className="question-bot-sapce">
                          <div className="question question-weight">
                            <span>Q25.</span>
                            <span className="quest-text-pad">
                              Describe the prescribed dosing information for
                              each agent used as part of the patient’s 1L NDMM
                              treatment with{" "}
                              <span
                                style={{ color: PageDesignConstants.fontColor }}
                              >
                                <b>
                                  {ndmmTreatmentCohortDetails.ndmmDisplayName}
                                </b>
                              </span>{" "}
                              initiated on{" "}
                              <span
                                style={{ color: PageDesignConstants.fontColor }}
                              >
                                <b>
                                  {ndmmTreatmentCohortDetails.ndmmIndexDate}
                                </b>
                              </span>
                              . <b><u>Please note the following:</u></b>
                              <br />
                              <b>
                                (a) Date of first administration for one of
                                the agents must match with the start date of
                                the 1L therapy on{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                  }}
                                >
                                  {ndmmTreatmentCohortDetails.ndmmIndexDate}
                                </span>
                              </b>
                              <br />
                              <b>
                                (b) Date of first administration of each
                                agent must be no later than the date of last
                                administration of the same agent
                              </b>
                              <br />
                              <b>
                                (c) None of the dates of first administration
                                or last administration should be later than
                                the end of follow up on{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                  }}
                                >
                                  {ndmmTreatmentCohortDetails.endOfFollowUp}
                                </span>
                                . Please note that, for patients receiving
                                one cycle of CyBorD, the date of initiation
                                of IL treatment begins with the first dose
                                of the DR/DRd, DVR/DVRd, VR/VRd, or
                                IsaVR/IsaVRd regimen.
                              </b>
                              <br />
                              <b>
                                (d) If the total number of administrations is
                                unknown, please provide information on
                                frequency of administration and number of
                                days per cycle of treatment (e.g., “Days 1,
                                8, and 15 of 21-day cycle for 2 cycles then
                                Days 1 and 15 of 21-day cycle for subsequent
                                cycles”).
                              </b>
                              <br />
                              <b>
                                (e) If a medication agent’s discontinuation
                                status is “No, medication ongoing at time of
                                last encounter” below, please enter the
                                “Date of the last administration” as the
                                last known administration date on or prior
                                to the patient’s last encounter date on{" "}
                                <span
                                  style={{
                                    color: PageDesignConstants.fontColor,
                                  }}
                                >
                                  {ndmmTreatmentCohortDetails.lastEncounterDate
                                    ? ndmmTreatmentCohortDetails.lastEncounterDate
                                    : "[date of last encounter]"}
                                </span>
                                .
                              </b>
                            </span>
                          </div>
                          <div className=" double-dig-answer">
                            <NDMMAgentData
                              phaseid={4}
                              agentList={
                                ndmmTreatmentCohortDetails.q25_agentList
                              }
                              agentData={
                                ndmmTreatmentCohortDetails.q25_agentData
                              }
                              setAgentData={(newData) =>
                                setNDMMTreatmentCohortDetails((prevState) => ({
                                  ...prevState,
                                  q25_agentData: newData,
                                }))
                              }
                              listToDelete={
                                ndmmTreatmentCohortDetails.nDMMAgentBridgeToDeleteLists
                              }
                              lastEncounterDate={
                                ndmmTreatmentCohortDetails.lastEncounterDate
                              }
                              hideOngoingOption={rrmmAvailable}
                            />
                          </div>
                        </div>
                        {/* Q25.1.A */}
                        {IsLenalidomideSelectedInQ25State && isNewEcrfA && (
                          <NDMMDosageModification
                            questionNumber="Q25.1.A"
                            phaseId={NDMMPhasesId.OtherTherapy} // TIE
                            agentName="Lenalidomide"
                            agentBridgeId={
                              ndmmTreatmentCohortDetails.q25_agentData?.find(
                                (a) => a.agentName === "Lenalidomide",
                              )?.agentBridgeId
                            }
                            agentFirstDate={
                              ndmmTreatmentCohortDetails.q25_agentData?.find(
                                (a) => a.agentName === "Lenalidomide",
                              )?.firstDate
                            }
                            agentLastDate={
                              ndmmTreatmentCohortDetails.q25_agentData?.find(
                                (a) => a.agentName === "Lenalidomide",
                              )?.lastDate
                            }
                            endOfFollowUpDate={
                              ndmmTreatmentCohortDetails.endOfFollowUp
                            }
                            dosageList={
                              ndmmTreatmentCohortDetails.q251_lenalidomideData
                            }
                            onDosageChange={(e, rowIndex, fieldName) =>
                              HandleLenalidomideDosageFieldChange(
                                4,
                                e,
                                rowIndex,
                                fieldName,
                              )
                            }
                            onDosageDateChange={(name, date, rowIndex) =>
                              HandleLenalidomideDosageDateChange(
                                4,
                                name,
                                date,
                                rowIndex,
                              )
                            }
                            onAddRow={() => AddLenalidomideDosageRow(4)}
                            onDeleteRow={(rowIndex) =>
                              DeleteLenalidomideDosageRow(4, rowIndex)
                            }
                          />
                        )}
                        {/* Q25.2A. */}
                        {isNewEcrfA &&
                          isBortezomibSelectedInQ25 &&
                          ndmmTreatmentCohortDetails
                            .q252ABortezomibDoseFrequencyList?.length > 0 && (
                            <DoseFrequencyModificationTable
                              key="q252ABortezomibDoseFrequencyList_OtherTheraphy"
                              title={{
                                code: "Q25.2A.",
                                text: (
                                  <>
                                    Please provide information on all{" "}
                                    <i>
                                      <u>
                                        bortezomib dose frequency modifications
                                      </u>{" "}
                                    </i>
                                    that occurred during{" "}
                                    <i>
                                      <u>1L treatment</u>
                                    </i>
                                    .
                                  </>
                                ),
                              }}
                              ndmmTreatmentCohortDetails={
                                ndmmTreatmentCohortDetails
                              }
                              treatmentRow={bortezomibDoseFrequencyRow}
                              treatmentName={NDMMCohortAgent.Bortezomib}
                              listKey="q252ABortezomibDoseFrequencyList"
                              ndmmPhasesId={NDMMPhasesId.OtherTherapy}
                              UpdateTreatmentDoseFrequencyList={
                                UpdateTreatmentDoseFrequencyList
                              }
                            />
                          )}
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NDMMTreatmentCohort;
